import React, { useState, useEffect, memo } from "react"

import Alert from 'react-bootstrap/Alert'
import Form from 'react-bootstrap/Form'
import FormControl from 'react-bootstrap/FormControl'
import Button from 'react-bootstrap/Button'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Spinner from 'react-bootstrap/Spinner'
import axios from "axios";
import $ from 'jquery';
import './panel.css';
import frm from './formAux.js'
import { Windows } from "react-bootstrap-icons"

var descriptor = {};
var origDescriptor = null;

var project;

var availModels = {};
window.availModels = availModels;


function px(v) { return v+'px'; }
function pc(v) { if( v < 0 ) v = 0; if( v > 100 ) v = 100; return Math.round(v)+'%'; }
function val(v) { v = parseFloat(v); if( isNaN(v) ) v = 0; return v }
function ival(v) { return Math.floor(val(v)) }
function isstring( o ){ return typeof(o) == 'string';}
function isarray( o ){ return o instanceof Array;}
function isobj( o ){ return o instanceof Object;}
function isnumber( o ){ return typeof(o) == 'number' && !isNaN(o);}
function defined( o ){ return typeof(o) != 'undefined';}
function clone(o) { return JSON.parse(JSON.stringify(o)); }
function getmsec(){	return new Date().getTime(); }
function getsec(){ return Math.round(getmsec()/1000); }
function nullFunc() { return null; }
function simplify(s) { return s.replace(/[^a-z0-9]/ig,'').toLowerCase() }
function iarray( v, n )
{
	var ret = [];
	for( var i = 0 ; i < n ; i++ )
	ret.push( v instanceof Object ? clone(v) : v );
	return ret;
}

function ckKPTProcessing() {
	if( descriptor.prelabelModel && descriptor.prelabelModel.length ) {
		$('.panel-keypair').hide();
	}
	else {
		$('.panel-keypair').show();
	}
}

function setModel( models ) {
	descriptor.prelabelModel = models;
	ckKPTProcessing()
	// descriptor.prelabelModelObj = availModels[model];
	descriptor.prelabelModelObj = null;
	for( let model of models ) {
		var m = availModels[model];
		// $('.prelabeldetails')[descriptor.prelabelModel && m.type.match(/custom/) ?'show':'hide']();
	
		if( !m ) return;
		var type = m.type;
		console.log( 'SETMODEL', m, 'availModels', type )
		// for( var k in m.labels ) {
		// 	if( !descriptor.labels[k] ) descriptor.labels[k] = m.labels[k];
		// }
		// for( var k in m.relationships ) {
		// 	if( !descriptor.relationships[k] ) descriptor.relationships[k] = m.relationships[k];
		// }
	}
	initPanel();
}

function setDescriptor( bool )
{
	for( var k in bool )
	{
		descriptor[k] = bool[k];
	}
}

function exists( o )
{
	if( !o ) return false;
	if( !isobj(o) ) return false;
	return Object.keys(o).length > 0;
}

function defaultCkeckboxes()
{
	if( !projectTypeCk('NER','Comprehend NER', 'OCR' ) ) return;
	var desc = {};
	if( descriptor.allowTextMode ) desc['texts'] = {default:false, label:'Text'};
	if( descriptor.allowAdjudication ) desc['adjudication'] = {default:false, label:'Adjudication'};
	if( descriptor.hasLabels ) desc['labels'] = {default:false, label:'Labels'};
	if( descriptor.hasRelationships ) desc['relationships'] = {default:false, label:'Relationships'};
	// if( descriptor.hasboxes ) desc['boxes'] = {label:'Boxes'};
	frm.booleanList( $('.project-settings2-bool'), frm.arr2Bool(descriptor.checkboxes_set), {
		items: desc,
		header: ['','Default toolbar checkbox values'],
		callbackOnInit: true,
		forceHeader: true,
	}, function(o){
		descriptor.checkboxes_set = frm.bool2Arr(o);
	} );
}

function exportDescriptor()
{
	if( !descriptor.hasBoxes ) descriptor.boxes = {};
	if( !descriptor.hasLabels ) descriptor.labels = {};
	if( !descriptor.hasRelationships ) descriptor.relationships = {};
	if( !descriptor.hasAttributes ) descriptor.attributes = {};
	console.log( JSON.stringify( descriptor, null, '\t') );
	return descriptor;
}

var modelLabels = {};

window.iii = initPanel;


function classificationLabels() {
	console.log( 'lllllllllllllllllllllll')
	if( !descriptor.classification ) descriptor.classification = [];
	var dom = $('#classification-labels');
	dom.html('');
	var idx = 0;

	function add( cidx ) {
		console.log( 'AAAAAAAAAAA', cidx )
		if( !cidx ) cidx = descriptor.classification.length
		descriptor.classification.splice( cidx, 0, { name: '', type: 'select', options: [] })
		classificationLabels();
	}
	function displayClassification( c )
	{
		var cdiv = $(`
			<div class="classification">
				<div class="classification-buttons">
					<button class="grey" cmd="up"><i class="fa fa-angle-up"></i></button><button class="grey" cmd="down"><i class="fa fa-angle-down"></i></button><button class="red" cmd="del"><i class="fa fa-close"></i></button><button class="green" cmd="add"><i class="fa fa-plus"></i></button>
				</div>
				<label htmlFor="className${idx}">Name/Question</label>
				<input placeholder="Enter name/question" type="text" id="className${idx}" class="mb-4 form-control"/>
				<label htmlFor="classType${idx}">Project Type</label>
				<select placeholder="Project Type" type="text" id="classType${idx}" class="mb-4 form-control">
				<option value="select">Single Select</option>
				<option value="multi">Multi Select</option>
				<option value="text">Plain Text</option>
				</select>
				<div class="optional"></div>
				<div id="classOptions${idx}"></div>
			</div>
		`);
		dom.append( cdiv );

		cdiv.find('button').off('click').on('click', function(){
			var dclass = descriptor.classification;
			var cidx = dclass.findIndex( dc => dc == c );
			var cmd = $(this).attr('cmd');
			console.log( cmd, cidx )
			if( cmd == 'up' )
			{
				if( cidx == 0 ) return;
				dclass.splice( cidx, 1 );
				dclass.splice( cidx-1, 0, c );
			}
			else if( cmd == 'down' )
			{
				if( cidx == dclass.length-1 ) return;
				dclass.splice( cidx, 1 );
				dclass.splice( cidx+1, 0, c );
			}
			else if (cmd == 'del') {
				// frm.myAlert('Delete Classification', 'Do you really want to delete this classification? ("'+c.name+'")<br><b>This action cannot be undone.</b>', 'Delete', function () {
					dclass.splice(cidx,1);
				// 	classificationLabels();
				// }, 'Cancel');
			}
			else add( cidx+1);
			classificationLabels();
		})
		cdiv.find(`#className${idx}`).val(c.name).on('change', function(){
			c.name = $(this).val();
		})
		cdiv.find(`#classType${idx}`).val(c.type).on('change', function(){
			if( c.type == $(this).val() ) return
			c.type = $(this).val();
			classificationLabels();
		})
		frm.booleanList(cdiv.find('.optional'), c, {
			items: {
				'optional': { default: false, label: 'Optional' },
			},
			callbackOnInit: true,
		}, function (o) {
			c.optional = o.optional;
			console.log( 'oooooooooo', c )
		});
		if (c.type != 'text') {
			frm.optionList(cdiv.find(`#classOptions${idx}`), frm.arr2Obj(c.options, 'label'), {
				fields: {
					'label': { type: 'text', placeholder: 'Enter Label', label: 'Label' },
					'alias': { type: 'text', placeholder: 'Enter Alias', label: 'Alias' },
				},
				defaultField: 'label',
				subLabels: false,
				maxSubLabels: 4,
				callbackOnInit: true,
			}, function (o) {
				// console.log( 'CLAAAAAAAA', frm.obj2Arr(o, 'label') )
				c.options = frm.obj2Arr(o, 'label');
			});
		}
		idx++;
	}
	setTimeout( function(){
		dom.html('');
		for( var c of descriptor.classification ) displayClassification( c );
		if (!descriptor.classification.length) add();
	}, 500 )
}

function imageAnnotationLabels()
{
	var lobj = null;
	var aobj = null;
	// descriptor.hasLabels = exists(descriptor.labels);
	// frm.booleanList($('.project-labels-bool'), descriptor, {
	// 	items: {
	// 		'hasLabels': { default: false, label: 'Enable Labels' },
	// 	},
	// 	callbackOnInit: true,
	// }, function (o) {
	// 	setDescriptor(o);
	// 	setTimeout(function () {
	// 		defaultCkeckboxes()
	// 		$('.project-labels')[o.hasLabels ? 'show' : 'hide']();
	// 	}, 1);
	// });

	$('.project-labels').show();
	function labelPanel() {
			if(window.GlobalVars.PDFProjectType !== "Segmentation"){
				var fields = {
					'color': { type: 'color', label: 'Color', className: 'option-color' },
					'label': { type: 'text', placeholder: 'Enter Label', label: 'Label', forceWidth: 200 },
					'keypoint': { type: 'boolean', label: 'KeyPoint', forceWidth: 100 },
					'linkto': { type: 'option', placeholder: 'Link to', label: 'Link To', className: 'option-model', forceWidth: 100, options: [] },
					'optional': { type: 'boolean', label: 'Optional', forceWidth: 80 },
				};

			}
			else{
				var fields = {
					'color': { type: 'color', label: 'Color', className: 'option-color' },
					'label': { type: 'text', placeholder: 'Enter Label', label: 'Label', forceWidth: 200 },
					// 'keypoint': { type: 'boolean', label: 'KeyPoint', forceWidth: 100 },
					// 'linkto': { type: 'option', placeholder: 'Link to', label: 'Link To', className: 'option-model', forceWidth: 100, options: [] },
					'optional': { type: 'boolean', label: 'Optional', forceWidth: 80 },
				};

			}

		

		if( !descriptor.labelAttributes ) descriptor.labelAttributes = {};
		for( var a in descriptor.labelAttributes ) {
			if( descriptor.labelAttributes[a].image ) continue;
			fields[a] = { type: 'boolean', className: 'labelAttributes', label: a, forceWidth: 80 };
		}
		// descriptor.labels = flatLabels(descriptor.labels)
		lobj = frm.optionList($('.project-labels'), descriptor.labels, {
			labelPlaceholder: 'Enter label name',
			fields: fields,
			defaultField: 'color',
			fieldKey: 'label',
			subLabels: true,
			maxSubLabels: 3,
			callbackOnInit: true,
			optionListFilter: linkFilter,
			optionListCallback: null,
			arrowCheck: hierarchyCheck
		}, function (o) {
			descriptor.labels = o;
			// console.log( 'xxxxxxxxxxxxxxxxxx', o )
			hierarchyCheck();
			// redraw = false;
		});
		console.log( 'LOBJ', lobj )
	}

	var hierarchyCheckTid = null;

	console.log('projecttype---->',projectType);
	console.log('projecttypeCheck------->',projectTypeCheck);



	

	function hierarchyCheck() {
		clearTimeout( hierarchyCheckTid );
		hierarchyCheckTid = setTimeout( function(){
			console.log( 'hierarchyCheck', lobj );
			var changed = false;
			var labs = descriptor.labels;
			var idx = 0;
			var lastL = null;
			for( var i = 0 ; i < lobj.list.length ; i++ )
			{
				var l = lobj.list[i];
				var v = l.value;
				var key = l.key;
				if( l.level == 0 && v.keypoint ) {
					v.keypoint = false;
					changed = true;
				}
				if( !v.keypoint && v.linkto ) {
					v.linkto = '';
					changed = true;
				}
				if( v.keypoint && lastL && lastL.value.keypoint && l.level != lastL.level) {
					l.level = lastL.level;
					changed = true;
				}
				// console.log( clone(validKeyPoints(lobj.list, i)), i, v.linkto )
				if( v.linkto && !validKeyPoints(lobj.list, i).find( o => o.value == v.linkto) ) {
					v.linkto = '';
					changed = true;
				}
				lastL = l;
			}
			if( changed ) lobj.draw();
		}, 100 );
		return true;
	}


	function validKeyPoints( o, idx, exclude ) {
		var list = [];
		var lev = o[idx].level;
		// console.log( lev );
		for( var i = idx ; i >= 0 ; i-- ) {
			var l = o[i].value;
			var lab = o[i].key;
			if( o[i].level != lev ) break;
			if( l.keypoint && o[i].level == lev &&  (!exclude || lab != exclude)) list.unshift( {value:lab,text:lab} );
		}
		for( var i = idx+1 ; i < o.length ; i++ ) {
			var l = o[i].value;
			var lab = o[i].key;
			if( o[i].level != lev ) break;
			if( l.keypoint && o[i].level == lev &&  (!exclude || lab != exclude)) list.push( {value:lab,text:lab} );
		}
		// console.log( 'validKeyPoints', list )
		return list;
	}


	function linkFilter( o, idx, field, list ) {
		console.log( 'linkFilter', o, idx, field, list );
		var vals = o[idx].value;
		if( !vals.keypoint ) return [];
		// return [{value:'aaa',text: 'HAHAHAHA'}];
		return validKeyPoints( o, idx, o[idx].key );
	}


	function attribPanel() {
		$('.panel-relationships').find('h1').html('Attributes')
		var hook = $('.project-relationships');
		hook.show().removeClass('project-relationships');
		var fields = {
			'label': { type: 'text', placeholder: 'Enter Attribute', label: 'Label', forceWidth: 120 },
			'options': { type: 'text', label: 'Options', placeholder: 'Option1,Option2,...', forceWidth: 300 },
			'optional': { type: 'boolean', label: 'Optional', forceWidth: 100 },
			'image': { type: 'boolean', label: 'Image attr.', forceWidth: 100 },
		};
		// descriptor.labelAttributes = flatLabels(descriptor.labelAttributes)
		aobj = frm.optionList( hook, descriptor.labelAttributes, { 
			labelPlaceholder: 'Enter label name',
			fields: fields,
			// defaultField: 'options',
			subLabels: false,
			maxSubLabels: 0,
			initValues: 8,
			callbackOnInit: true,
		}, function (o) {
			descriptor.labelAttributes = o;
			console.log( 'xxxxxxxxxxxxxxxxxx', o )
			attribCheck();
			// hierarchyCheck();
			// redraw = false;
		});
		console.log( 'LOBJ', lobj )
	}

	var attribCheckTid = null;
	function attribCheck() {
		clearTimeout( attribCheckTid );
		attribCheckTid = setTimeout( function(){
			console.log( 'attribCheck', aobj )
			var changed = false;
			for( var a of aobj.list ) {
				var s = a.value.options;
				var ol = a.value.options.split(',').map( o => o.toString().trim() ).filter( o => o ).join(', ');
				if( s != ol ) {
					a.value.options = ol;
					changed = true;
				}
				console.log( 'AAAAAAAAAAAAAA', a, s, ol )
			}
			if( changed ) aobj.draw();
			else labelPanel();
		}, 100 );
	}

	$('.panel-prelabel').hide();
	$('.panel-autolabel').hide();
	$('.panel-keypair').hide();
	$('.panel-boxes').hide();

	labelPanel();
	attribPanel();
}

function awsTypeChange() {
	var type = $('#awstype').val();
	$('.awstyperole').hide();
	$('.awstypekey').hide();
	if( type == 'role' ) $('.awstyperole').show();
	if( type == 'key' ) $('.awstypekey').show();
}

var models = [];

function getModel( id ) {
	return models.find( m => m.id == id || m.model == id )
}

var modulesDone = false;
async function nerLabels() {
	if( !modulesDone ) {

		// 
		try {
				window.models = models = [];
				if( projectTypeCk('NER')) {
					let res = await window.post('get_models', {} )
					if( !res.data ) res.data = {};
					window.models = models = res.data.models || [];
				}
				for( let m of models ) m.id = null;
				modulesDone = true;
				var modList = {};
				descriptor.customModels = {};
				console.log('availModels', availModels)
				for( var mk in availModels ) {
					var m = availModels[mk];
					// if( !m.type.match(/custom/) ) continue;
					// console.log( 'AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAa', m )
					var a =  {
						id: m.id,
						model: m.name,
						type: m.type,
						categories: Object.keys(m.labels).map( k => {return {type:k,description:''}} )
					};
					modList[m.name] = 1;
					descriptor.customModels[m.name] = m.id;
					models.push( a )
				}
				for (var m of models) {
					modList[m.id || m.model] = 1;
					modelLabels[m.id || m.model] = m.categories.map(c => { return { value: c.type, text: c.type + (c.description ?' - ' + c.description:'') } });
					if (!(m.model in descriptor.models)) {
						descriptor.models[m.model] = false;
					}
				}
				console.log( 'descriptor.autoLabelModel', descriptor.autoLabelModel );
				var items = {};
				let mlist = [];
				let mselect = [];
				for (let model of models) {
					console.log( 'getModel', m, model )
					// items[k] = { default: false, label: k };
					mlist.push( {label:model.model, value:model.id || model.model});
					// if( descriptor.models[k] ) mselect.push( k )
				}
				var tid = null;
				frm.itemList( $('.project-models-input'), mlist, descriptor.autoLabelModel, { width: 450, placeholder: 'Select Models'}, function(v) {
					// console.log( 'VVVVVVVVVVVVVVVVVV', v)
					// let m = {};
					// for (var k in descriptor.models) {
					// 	m[k] = v.indexOf(k) >= 0;
					// }
					// console.log( 'MMMMM', m )
					// descriptor.models = m;
					descriptor.autoLabelModel = v;
					clearTimeout(tid);
					$('.option-list-options').remove();
					tid = setTimeout( labelPanel, 10 );
					// labelPanel();
					// alert( v )
					// setModel( v );
				})

				// frm.booleanList($('.project-models-bool'), descriptor.models, {
				// 	items: items,
				// 	header: ['', 'Model'],
				// 	callbackOnInit: true,
				// }, function (o) {
				// 	// console.log('MODEL', o)
				// 	descriptor.models = o;
				// 	clearTimeout(tid);
				// 	$('.option-list-options').remove();
				// 	tid = setTimeout( labelPanel, 10 );
				// 	// alert('xxx')
				// 	// setDescriptor(o);
				// 	// setTimeout( function(){
				// 	//     defaultCkeckboxes()
				// 	// },1 )
				// });
	
			} catch (e) { console.error(e)}
	}
	descriptor.hasLabels = exists(descriptor.labels);
	function bval( v ) { return v || false }
	function kpBool() {
		if( !projectTypeCk('OCR') ) return $('.panel-keypair').hide();

		$('.project-keypair-drop').html('');
		let tlist = [
			{value:'', label:"Clear key-pair model"},
			{value:'awsdefault', label:"AWS Textract Table Detection Model"},
		]
		frm.dropDown($('.project-keypair-drop'), tlist, descriptor.useTablemodel, {placeholder:'Select Table Detection Model', width: 450}, function(v){
			if( v == descriptor.useTablemodel ) return;
			descriptor.useTablemodel = v;
			setTimeout( nerLabels, 100 )
		} ).addClass('imgcls-dropdown-setup');

		$('.project-keypair-drop').append($('<BR>'))
		let mlist = [
			{value:'', label:"Clear key/value model"},
			{value:'awsdefault', label:"AWS Textract Key/Value Detection Model"},
		]
		frm.dropDown($('.project-keypair-drop'), mlist, descriptor.useKeypairmodel, {placeholder:'Select Key/Value Detection Model', width: 450}, function(v){
			if( v == descriptor.useKeypairmodel ) return;
			descriptor.useKeypairmodel = v;
			setTimeout( nerLabels, 100 )
		} ).addClass('imgcls-dropdown-setup');


		var textractItems = {
			// 'useTablemodel': { default: false, label: 'Extract Tables using Amazon Textract' },
			// 'useKeypairmodel': { default: false, label: 'Extract Key value pairs using Amazon Textract' },
			// 'useKeypairDic': { default: false, label: 'Enable Key value pairs dictionary' },
			// 'dictionaryMatchKeysOnly': { default: false, label: 'Dictionary: match keys only' },
			// 'dictionaryIgnoreNoMatch': { default: false, label: 'Dictionary: ignore non matching key-value pairs' },
		}
		if( descriptor.useKeypairmodel ) {
			textractItems.useKeypairDic = { default: false, label: 'Enable Key value pairs dictionary' };
		}
		if( descriptor.useKeypairmodel && descriptor.useKeypairDic ) {
			textractItems.dictionaryMatchKeysOnly = { default: false, label: 'Dictionary: match keys only' };
			textractItems.dictionaryIgnoreNoMatch = { default: false, label: 'Dictionary: ignore non matching key-value pairs' };
		}
		if( projectTypeCk('Comprehend NER') ) {
			delete textractItems.useKeypairmodel;
		}
		frm.booleanList($('.project-keypair-bool'), descriptor, {
			items: textractItems,
			callbackOnInit: true,
		}, function (o) {
			if( textractItems.useKeypairDic && bval(o.useKeypairDic) != bval(descriptor.useKeypairDic) ) {
				console.log( 'userKeypairDic', bval(o.useKeypairDic), bval(descriptor.useKeypairDic) )
				setTimeout( nerLabels, 100 )
			}
			// if( o.useKeypairmodel != descriptor.useKeypairmodel ) {
			// 	console.log( 'useKeypairmodel' )
			// 	setTimeout( nerLabels, 100 )
			// }
			setDescriptor(o);
			setTimeout(function () {
				defaultCkeckboxes();
			}, 1);
		});
	}
	kpBool();
	
	descriptor.hasLabels = exists(descriptor.labels);
	frm.booleanList($('.project-labels-bool'), descriptor, {
		items: {
			'hasLabels': { default: false, label: 'Enable Labels' },
		},
		callbackOnInit: true,
	}, function (o) {
		setDescriptor(o);
		setTimeout(function () {
			defaultCkeckboxes()
			$('.project-labels')[o.hasLabels ? 'show' : 'hide']();
		}, 1);
	});
	
	function flatLabels(labels) {
		if (!labels) return null;
		var list = [];
		function walk(labels) {
			for (var k in labels) {
				var o = clone(labels[k]);
				delete o.sublabels;
				o.name = k.replace(/:(KEY|VAL)$/, '');
				list.push(o);
				if (labels[k].sublabels) walk(labels[k].sublabels);
			}
		}
		walk(labels);
		var labs = {};
		
		list.forEach(li => {
			labs[li.name] = li;
		});
		// console.log('flatLabels', clone(labels), clone(labs))
		return labs;
	}
	
	function singleOption( olist, cname, f, val, idx ) {
		console.log( 'single option', olist, cname, f, val, idx )
		$('.'+cname).each( (eidx,e) => {
			if( eidx != idx && $(e).val() == val ){
				// console.log( 'element', eidx, $(e).val() );
				$(e).val('')
				olist[eidx].value[f] = ''
				// $(e).change();
			}
		})
	}
	
	
	function labelPanel() {
		var fields = {
			'color': { type: 'color', label: 'Color', className: 'option-color' },
			'label': { type: 'text', placeholder: 'Enter Label', label: 'Label' },
			'alias': { type: 'text', placeholder: 'Enter Alias', label: 'Alias', className: 'option-alias' },
		};
		if( projectType == 'OCR' ) {
			var fields = {
				'color': { type: 'color', label: 'Color', className: 'option-color' },
				'label': { type: 'text', placeholder: 'Enter Label', label: 'Label' },
				'keyset': { type: 'boolean', label: 'key-pair', forceWidth: 100 },
				'alias': { type: 'text', placeholder: 'Enter Alias', label: 'Alias', className: 'option-alias' },
			};
		}
		console.log( 'descriptor.models', descriptor.models, 'modelLabels', modelLabels, 'availModels', availModels )
		let mlist = [];
		if( descriptor.prelabelModel ) mlist.push( descriptor.prelabelModel )
		if( descriptor.autoLabelModel ) mlist.push( descriptor.autoLabelModel )
		mlist = frm.aUnique(mlist.flat());
		console.log( 'MODELABELS', mlist )
		// alert( Object.keys( descriptor.labels ))

		// add the modules list
		for (var m of mlist ) {
			let md = getModel(m);

			if( !md ) continue;
			var lab = md.model.replace(/\-/g, ' ');
			let mid = md.id || md.model;
			console.log( 'mmmmmmmmmmmmmmmm', md, mid, modelLabels[mid] )
			fields[mid] = { 
				type: 'option', 
				placeholder: 'Select Label', 
				label: lab, 
				className: 'option-model', 
				options: modelLabels[mid],
			};
			if( modelLabels[mid] ) {
				// delete descriptor.labels[mid];
				console.log( 'MMMMMMMMMMMMMMMMMMMMMMMMMMMM', mid, modelLabels[mid] )
				for( var mo of modelLabels[mid] ) {
					if( mo.value in descriptor.labels && !(mid in descriptor.labels[mo.value]) ) {
						descriptor.labels[mo.value][mid] = mo.value
					}
				}
			}
		}
		delete fields.dictionary
		if( descriptor.useKeypairmodel && descriptor.useKeypairDic && projectTypeCk('OCR') ) {
			fields.dictionary = { type: 'text', placeholder: 'Dictionary paterns (comma separated)', label: 'Dictionary', forceWidth: 400 }
		}
		console.log( 'FIELDS', clone(fields))
		
		descriptor.labels = flatLabels(descriptor.labels)
		frm.optionList($('.project-labels'), descriptor.labels, {
			labelPlaceholder: 'Enter label name',
			fields: fields,
			defaultField: 'color',
			fieldKey: 'label',
			// subLabels: true,
			// maxSubLabels: 2,
			callbackOnInit: true,
			optionListCallback: singleOption,
		}, function (o) {
			descriptor.labels = o;
		});
	}
	setTimeout( labelPanel, 10 )
	
	if( projectTypeCk('NER','Comprehend NER')) {
		
		descriptor.hasRelationships = exists(descriptor.relationships);
		
		frm.booleanList($('.project-relationships-bool'), descriptor, {
			items: {
				'hasRelationships': { default: false, label: 'Enable Relationships' },
			},
			callbackOnInit: true,
		}, function (o) {
			setDescriptor(o);
			setTimeout(function () {
				defaultCkeckboxes()
				$('.project-relationships')[o.hasRelationships ? 'show' : 'hide']();
			}, 1);
		});
		
		frm.optionList($('.project-relationships'), descriptor.relationships, {
			labelPlaceholder: 'Enter label name',
			fields: {
				'label': { type: 'text', placeholder: 'Enter Label', label: 'Label' },
				'color': { type: 'color', label: 'Color' },
			},
			defaultField: 'color',
			subLabels: false,
			maxSubLabels: 0,
			callbackOnInit: true,
		}, function (o) {
			descriptor.relationships = o;
		});
	}
	else {
		$('.panel-relationships').hide();

	}
	
	if( projectTypeCk('NER')) {
	
		descriptor.hasboxes = exists(descriptor.boxes);
		frm.booleanList($('.project-boxes-bool'), descriptor, {
			items: {
				'hasboxes': { default: false, label: 'Enable Bounding Boxes' },
			},
			callbackOnInit: true,
		}, function (o) {
			setDescriptor(o);
			setTimeout(function () {
				defaultCkeckboxes()
				$('.project-boxes')[o.hasboxes ? 'show' : 'hide']();
			}, 1);
	
		});
	
		frm.optionList($('.project-boxes'), descriptor.boxes, {
			fields: {
				'label': { type: 'text', placeholder: 'Enter Label', label: 'Label' },
				'color': { type: 'color', label: 'Color' },
			},
			defaultField: 'color',
			subLabels: false,
			maxSubLabels: 0,
			callbackOnInit: true,
		}, function (o) {
			descriptor.boxes = o;
		});
	}
	else {

	}
	if( projectTypeCk('NER','Comprehend NER', 'OCR', 'TEXT_QA', 'Content Generation') ) {
		$('.page-attributes').show();
		descriptor.hasPageAttributes = exists(descriptor.pageAttributes);
		frm.booleanList($('.page-attributes-bool'), descriptor, {
			items: {
				'hasPageAttributes': { default: false, label: 'Enable Page Attributes' },
			},
			callbackOnInit: true,
		}, function (o) {
			setDescriptor(o);
			setTimeout(function () {
				$('.page-attributes')[o.hasPageAttributes ? 'show' : 'hide']();
			}, 1);
		});
	
	
		frm.optionList($('.page-attributes'), frm.arr2Obj(descriptor.pageAttributes, 'label'), {
			fields: {
				'label': { type: 'text', placeholder: 'Enter Attribute', label: 'Label' },
				'optional': { type: 'boolean', label: 'Optional', forceWidth: 100 },
				'allowNew': { type: 'boolean', label: 'Allow New', forceWidth: 100 },
				'options': { type: 'list', label: 'Options', placeholder: 'Enter Options' },
			},
			defaultField: 'options',
			subLabels: false,
			maxSubLabels: 0,
			initValues: 8,
		}, function (o) {
			descriptor.pageAttributes = frm.obj2Arr(o, 'label');
		});
		if( projectTypeCk('OCR')) {
			$('.panel-boxes').hide();
		}
	}
	else {
		$('.panel-prelabel').hide();
		$('.panel-autolabel').hide();
		$('.panel-relationships').hide();
		$('.panel-boxes').hide();
	}

	// if( projectTypeCk('Comprehend NER', 'OCR')) 
	if( projectTypeCk('Comprehend NER')) 
	{
		// $('.panel-prelabel').hide();
		// $('.panel-autolabel').hide();
		$('.panel-boxes').hide();
	}
	// if( projectTypeCk('Comprehend NER') ) {
		// $('.panel-prelabel').show();
	// }
	
}

function initPanel()
{
    window.descriptor = descriptor;
	var pInit = {};


	if( currentMode == 2 && projectTypeCk('TEXT_QA', 'Content Generation') ) {
		let qmodel = frm.configSection( $('.panel_qa'), 'Pre-Labeling Model', true );
		let modelcfg = [
			{
				"key": "enablePrelabelingModel",
				"label": "Enable Pre-Labeling Model",
				"type": "boolean",
				"default": false,
				"subFields": [
					{
						"title": "Use Pre-Labeling Q&A Model",
						"key": "qaModel",
						"type": "dropdown",
						"placeholder": "Select Q&A model",
						"options": [
							{
								"value": "OpenAI GPT-3",
								"label": "Q&A Prompt GPT-3.5-turbo",
								"filter": [
									"PDF",
									"Text",
									"PDFOCR"
								],
								"subFields": [
									{
										"title": "Key",
										"key": "qaModelKey",
										"placeholder": "OpenAI Key",
										"type": "string"
									}
								]
							}
						]
					}
				]
			}
		];
        frm.configOptions(qmodel, modelcfg, descriptor);

		let nc = frm.configSection( $('.panel_qa'), 'Q&A Settings', true );

		nc.html('<div class="opts_qa">');
		let fields = {
			'color': { type: 'color', label: 'Color', className: 'option-color' },
			'name': { type: 'text', placeholder: 'Enter short alias name', label: 'Name', forceWidth: 200},
			'instruction1': { type: 'textarea', placeholder: 'Enter Label', label: 'Question Instruction', forceWidth: 300, forceHeight: 80 },
			// 'instruction2': { type: 'textarea', placeholder: 'Enter Label', label: 'Answer Instruction', forceWidth: 300, forceHeight: 80 },
			'summary': { type: 'boolean', label: 'Only summary', forceWidth: 80 },
			'distribution': { type: 'text', default: '1', placeholder: 'Distribution', label: 'Distribution', forceWidth: 100 },
		};
		// Only add Answer Instruction field if NOT in Content Generation mode
        if( !projectTypeCk('Content Generation') ) {
          fields['instruction2'] = { type: 'textarea', placeholder: 'Enter Label', label: 'Answer Instruction', forceWidth: 300, forceHeight: 80 };
       }
		console.log( '###########################', JSON.stringify(descriptor) )

		let lobj = frm.optionList($('.opts_qa'), descriptor.questions, {
			fields: fields,
			defaultField: 'name',
			fieldKey: 'name',   //skip the name field 
			callbackOnInit: true,
			// arrowCheck: hierarchyCheck
		}, function (o) {
			for( let qo of Object.values(o) ) if( !qo.distribution ) qo.distribution = 100;
			descriptor.questions = o;
		});
	}

	//dhinesh 





	if( currentMode == 2 && projectTypeCk('Content Generation','TEXT_QA','NER', 'Comprehend NER', 'OCR', 'Classification','Response Generation') ) {
		let taskInstructions = frm.configSection( $('.instructions-panel'), 'Global Task Instructions', true );
		let instructionscfg = [
			{
				"key": "globalTaskInstructions.text",
				// "title": "Global task instructions for annotator",
				"type": "textarea",
				"default": "",
				"placeholder": "Enter instructions for annotator",
				"css": {height: 300},
			},
			// add modal option boolean
			{
                "key": "globalTaskInstructions.showModal",
                // "title": "",
                "label": "Enable task instructions popup",
                "type": "boolean",
                "default": false,
            }, 
		];
        frm.configOptions(taskInstructions, instructionscfg, descriptor);
	}



	pInit[projectName] = {active: true};
	$('.panel-prelabel').hide();
	if( projectActive )
	{
		$('#projectid').html('ID: '+PDFProjectId);
	}
	$('#projectname').val(projectName).on('change', function(ev){
		projectName = $(this).val().trim();
	})
	$('#projectdescription').val(projectDescription).on('change', function(ev){
		projectDescription = $(this).val().trim();
	})
	$('#projecttype').val(projectType).on('change', function(ev){
		projectType = $(this).val().trim();
		console.log('projecttype------>',projectType);
		// window.GlobalVars.PDFProjectType
		
		var cantrain = projectType == 'Bulk Image Classification';
		if( !cantrain ) projectTraining = false;
		$('#trainingproject').prop('checked',projectTraining)
		$('.trainckbox')[cantrain?'show':'hide']()
	})
	$('#projecttypecheck').val(projectTypeCheck).on('change', function(ev){
		projectTypeCheck = $(this).val().trim();
	})
	$('.trainckbox').on('click', ev => {

		$('#trainingproject').click();
		ev.preventDefault();
		ev.stopPropagation();
	}).css({cursor:'pointer'})
	$('#trainingproject').prop('checked',projectTraining)
	.on('click', function(ev){
		projectTraining = $(this).prop('checked');
		ev.stopPropagation();
	})

	var cantrain = projectType == 'Bulk Image Classification';
	$('.trainckbox')[cantrain?'show':'hide']()
	// if( projectActive ) {
	// 	setTimeout( function(){
	// 		$('#projecttype').attr( 'disabled',true);
	// 		$('#trainingproject').attr('disabled', true)
	// 		// alert(projectTraining)
	// 		if( !projectTraining ) $('.trainckbox').hide();

	// 	},150 )
	// }
	if (projectActive) {
		setTimeout(function () {
			$('#projecttypecheck').removeAttr('onclick');
			$('#projecttypecheck').empty();
			var newProjectOption = $('<option>', {
				value: project.p_type,
				text: project.p_type,
			});
			console.log("project----->",project);
			
			$('#projecttypecheck').append(newProjectOption);
			
			if (!projectTraining) {
				$('.trainckbox').hide();
			}
			$('#projecttypecheck').attr('disabled', true);
			setTimeout(() => {
				$('#projecttype').empty();
				$('#projecttype').removeAttr('onclick');
				if(project.type == "Pose Estimation"){
					var newOption = $('<option>', {
						value: "Bounding Box",
						text: "Bounding Box",
					});
				}
				else{
					var newOption = $('<option>', {
						value: project.type,
						text: project.type,
					});
				}
				$('#projecttype').append(newOption);
				$('#projecttype').attr('disabled', true);
			}, 110);
		}, 100);
	}
	
	// if( descriptor.useTablemodel ) descriptor.allowTableMode = true;
	var settings = {
		// 'allowTextOffset': { default: false, label: 'Allow Text Offset Adjustment' },
		'allowTextMode': { default: false, label: 'Allow Text Mode' },
		'allowTableMode': { default: false, label: 'Allow Table Mode' },
		// 'allowAdjudication': { default: false, label: 'Allow Adjudication' },
		// 'reviewMode': { default: false, label: 'Set Review Mode' },
		// 'blockEdit': { default: false, label: 'Block New Annotations and Editing' },
		// 'exportAllPlainTextPages': { default: false, label: 'Export plain text for all pages' },
		'disableOverlap': { default: false, label: 'Disable Tag Overlap' },
		'disableQC': { default: false, label: 'Disable Quality Audit' },
		'qcMayRequestAdjustment': { default: false, label: 'QC may request adjustments' },
		'allowLabelInput': { default: false, label: 'Allow New Label Input' },
		// 'deleteDuplicates': { default: false, label: 'Automaticaly Delete Duplicated Files' },
		'allowBoxRotation': { default: false, label: 'Allow Bounding Box Rotation' },
		'textFilePageBreak': { default: true, label: 'Break text files in pages' },
		// 'usePDFPlumber': { default: false, label: 'Use Engine Mode 2 (PDF Plumber)' },
	};
	var delSettings = {
		'NER': ['allowTableMode', 'hasAWSCredentials'],
		'Comprehend NER': ['textFilePageBreak', 'disableOverlap','allowBoxRotation'],
		'OCR': ['textFilePageBreak', 'disableOverlap', 'hasAWSCredentials', 'exportFormat', 'disableOverlap'],
		'TEXT_QA': ['allowTableMode','allowTextMode', 'exportAllPlainTextPages', 'disableOverlap', 'allowLabelInput','allowBoxRotation'],
		'Content Generation': ['allowTableMode','allowTextMode', 'exportAllPlainTextPages', 'disableOverlap', 'allowLabelInput','allowBoxRotation'],
		'Pose Estimation': ['textFilePageBreak','allowTableMode','allowTextMode', 'exportAllPlainTextPages', 'disableOverlap', 'allowLabelInput','allowBoxRotation'],
		'Classification': ['textFilePageBreak','allowTableMode','labels','relationships', 'boxes', 'allowTextMode', 'exportAllPlainTextPages', 'disableOverlap','checkboxes_set','allowBoxRotation'],
		'Media Transcription': ['textFilePageBreak','labels','relationships', 'boxes', 'allowTableMode','allowTextMode', 'exportAllPlainTextPages', 'disableOverlap','checkboxes_set','allowBoxRotation'],
		'AmEx Audio Templete': ['allowLabelInput','textFilePageBreak','labels','relationships', 'boxes', 'allowTableMode','allowTextMode', 'exportAllPlainTextPages', 'disableOverlap','checkboxes_set','allowBoxRotation'],
		'Code Switching': ['allowLabelInput','textFilePageBreak','labels','relationships', 'boxes', 'allowTableMode','allowTextMode', 'exportAllPlainTextPages', 'disableOverlap','checkboxes_set','allowBoxRotation'],
		'Bulk Image Classification': ['textFilePageBreak','allowTableMode','labels','relationships', 'boxes', 'allowTextMode', 'exportAllPlainTextPages', 'disableOverlap','checkboxes_set', 'qcMayRequestAdjustment', 'deleteDuplicates','allowLabelInput','allowBoxRotation'],
		'Segmentation': ['textFilePageBreak','allowTableMode','allowTextMode', 'exportAllPlainTextPages', 'disableOverlap', 'allowLabelInput','allowBoxRotation'],
		'Key Point': ['textFilePageBreak','allowTableMode','allowTextMode', 'exportAllPlainTextPages', 'disableOverlap', 'allowLabelInput','allowBoxRotation'],
		'Response Generation':['textFilePageBreak','allowTableMode','labels','relationships', 'boxes', 'allowTextMode', 'exportAllPlainTextPages', 'disableOverlap','checkboxes_set','allowBoxRotation']

	};
	for( var f of delSettings[projectType] ) delete settings[f];
	$('.prelabeldetails')[descriptor.prelabelModel && availModels && availModels[descriptor.prelabelModel] && !availModels[descriptor.prelabelModel].type.match(/custom/) ?'show':'hide']();

	if( projectTraining ) delete settings.disableQC;

	if( projectTypeCk('TEXT_QA', 'Content Generation')) {
		settings.requestTextHighlightQ = { default: false, label: 'Request text highlight for Question annotations' }
		settings.requestTextHighlightA = { default: false, label: 'Request text highlight for Answer annotations' }
		settings.requestTextHighlightS = { default: false, label: 'Request text highlight for Sumarization annotations' }
	}


	if( currentMode == 3 ) $('.project-settings').show();
	if( !Object.keys(settings).length ) $('.project-settings').hide();

	if( projectTypeCk('Media Transcription') || projectTypeCk('AmEx Audio Templete'|| projectTypeCk('Code Switching') ) ) {
		let mediaCfg = [
			{
				"key": "media_time_offset",
				"title": "Initial time offset for media annotations",
				"placeholder": "Enter offset seconds",
				"type": "timemilliseconds",
				"default": 0,
			}
		];
        frm.configOptions( $('.media-segmentation-section'), mediaCfg, descriptor);
	}


	if (1 && projectTypeCk('') ) {
		console.log("---------------->");
		
		ckKPTProcessing()
		if( !Object.keys(availModels).length ) {
			console.log('------------->');
			
			let mtype = 'custom_ner';
			if( projectTypeCk('Comprehend NER', 'OCR')) mtype = 'custom_ocr';
			window.post('find_models', { match: { company: projectCompany, type: mtype } }, res => {
				try {
					var types = projectTypeCk('OCR','Comprehend NER') ? {custom_ocr:1} : {custom_ner:1,sagemaker:1};
					var list = res.data.records || [];
					// let mlist = [{label:'Clear All',value:''}];// modify  &nbsp; to Clear All 
					let mlist = [];// modify  &nbsp; to Clear All 
					for (var i = 0; i < list.length; i++) {
						if( !types[list[i].type]) continue;
						availModels[list[i].id] = list[i];
						mlist.push( {label:list[i].name,value:list[i].id})
					}
					$('.panel-prelabel').show();
					
					$('#prelabelcontainer').html('');
					// frm.dropDown($('#prelabelcontainer'), mlist, descriptor.prelabelModel2, {placeholder:'Select Pre-label Model', width: 450}, function(v){
					// 	// if( v == descriptor.prelabelModel ) return;
					// 	// setModel( v );
					// } ).addClass('imgcls-dropdown-setup');
					frm.itemList( $('#prelabelcontainer'), mlist, descriptor.prelabelModel, { width: 450, placeholder: 'Select Models'}, function(v) {
						// alert( v )
						setModel( v );
					})
					// frm.itemList($('#prelabelcontainer'), mlist, descriptor.prelabelModel, {placeholder:'Select Pre-label Model', width: 450}, function(v){
						// 	// if( v == descriptor.prelabelModel ) return;
						// 	// setModel( v );
						// } ).addClass('imgcls-dropdown-setup');
					console.log('FIND_MODELS', availModels )
					drawModels();
				} catch (e) { }
			})
		}
		else drawModels();
		
	}
	else initPanel2();

	function drawModels() {
		var list = Object.values(availModels);
		// alert( list )
		// for (var i = 0; i < list.length; i++) {
		// 	$('#prelabel').append($('<option>').prop('value',list[i].id).html(list[i].name));
		// }
		if( list.length ) {
			$('.panel-prelabel').show();
			$('#prelabel').off('change').on('change', function(){
				var model = $('#prelabel').val();
				setModel( model );
			});
			$('#prelabel').val(descriptor.prelabelModel)
			if( !descriptor.prelabelModelTaskNum ) descriptor.prelabelModelTaskNum = 100;
			$('#prelabeltasknum').val(descriptor.prelabelModelTaskNum).off('change').on('change', ev => { descriptor.prelabelModelTaskNum = $('#prelabeltasknum').val()} )
			if( !descriptor.prelabelModelSchedule ) descriptor.prelabelModelSchedule = 10;
			$('#prelabelschedule').val(descriptor.prelabelModelSchedule).off('change').on('change', ev => { descriptor.prelabelModelSchedule = $('#prelabelschedule').val()} )
		}
		initPanel2();
	}

	function initPanel2() {
		console.log( 'initPanel2')
		console.log('projecttype---->',projectType);
		
		if (projectType) {
			console.log('init-<2');
			
            document.getElementById('projecttype').value = projectType;
        }
		
		if( projectType == 'Media Transcription' ) {
			settings.transcriptionMode = { default: true, label: 'Enable Transcription Mode' }
			settings.allow_media_markers = { default: false, label: 'Allow single frame marker annotations' }
			settings.allow_media_regions = { default: true, label: 'Allow range annotations' }
		}
		if(  projectType == 'Code Switching') {
			settings.allow_media_regions = { default: true, label: 'Allow range annotations' }
		}
	
	
		if( projectTypeCk('Comprehend NER','OCR') ) {
			// settings.useTextract = { default: false, label: 'Use Amazon Textract for OCR' }
		}
	
		if( projectTypeCk('OCR') ) {
			settings.disableAutoKeyPairLinking = { default: false, label: 'Disable Automatic Key-pair Linking' }
		}
		if( projectTypeCk('NER', 'Comprehend NER','OCR','Pose Estimation','Media Transcription','AmEx Audio Templete','Code Switching','TEXT_QA','Content Generation','Segmentation','Key Point','Response Generation') ) {
			settings.fullListMode = { default: false, label: 'List all tasks to Annotation/Review team' }
		}

		if( projectType == 'Pose Estimation' ) {
			settings.enableOutsideImage = { default: true, label: 'Enable Outside Image Flag for missing annotations' }
			settings.enableOccluded = { default: true, label: 'Enable Occluded Flag for missing annotations' }
		}

		if( projectType == 'Segmentation' ) {
			settings.enableOutsideImage = { default: false, label: 'Enable Outside Image Flag for missing annotations' }
			settings.enableOccluded = { default: false, label: 'Enable Occluded Flag for missing annotations' }
		}
		if( projectType == 'Key Point' ) {
			settings.enableOutsideImage = { default: false, label: 'Enable Outside Image Flag for missing annotations' }
			settings.enableOccluded = { default: false, label: 'Enable Occluded Flag for missing annotations' }
		}
	
	
		frm.booleanList( $('.project-settings-bool'), descriptor, {
			items: settings,
			header: ['','Project Attributes'],
			callbackOnInit: true,
		}, function(o){
			setDescriptor(o);
			$('.qcMayRequestAdjustment')[o.disableQC?'hide':'show']();
			if ( projectTypeCk('NER','TEXT_QA','Content Generation') ) $('.project-word-page-break')[o.textFilePageBreak?'show':'hide']();
			setTimeout( function(){
				defaultCkeckboxes()
				$('.maximum-concurrent')[descriptor.fullListMode ? 'hide':'show']()
			},1 )
		} );
	
		if (descriptor.annotatorsPerTask * 1 > 1) {
			$('.qcMayRequestAdjustment').hide();
			descriptor.qcMayRequestAdjustment = false;
		}
	
		if( !descriptor.models ) descriptor.models = {};
		if ( projectTypeCk('NER','Comprehend NER', 'OCR','TEXT_QA','Content Generation', 'Bulk Image Classification') && currentMode >= 2 ) nerLabels();
		if ( projectTypeCk('Pose Estimation') || projectTypeCk('Segmentation') || projectTypeCk('Key Point')  && currentMode >= 2 ) imageAnnotationLabels();
		else if( projectTypeCk('Classification','Response Generation') ) classificationLabels()
	
				// <div className="media-segmentation-section">
				//     <h1>Media Segmentation</h1>
				//     <div className="media-segmentation-bool"></div>
				//     <div className="media-segmentation-attributes"></div>
				// </div>

		$('.project-annotators-per-task').hide();
		if (projectTypeCk('Bulk Image Classification')) {
			$('.bookmark-reference').show()
			$('#bookmarkURL').css({width:500}).val(descriptor.bookmarkURL).on('change', function(){
				descriptor.bookmarkURL = $(this).val().trim();
			});
			if( projectTraining ) {
				$('.project-annotators-per-task').hide();
				$('.consensus-mode').hide();
				// $('.min-consensus-annotators').hide();
				$('.maximum-concurrent').hide();
				$('.training-mode').show();
				
				if( !descriptor.training ) descriptor.training = {};
				window.post('list_badges', {}, bres => {
					var keys = bres.data;
					window.dqual = frm.dropDown($('.qualification'), keys, descriptor.training.qualificationName, {allowNew:true,width:250}, function(v){
						descriptor.training.qualificationName = v;
					} ).addClass('imgcls-dropdown-setup');
				})
				$('#trainingQualificationName').off('change').on('change', function(){
					descriptor.training.qualificationName = $(this).val().trim();
				}).val( descriptor.training.qualificationName || '');

				var expOpt = [
					{value:0, label:"Never"},
					{value:0.0416, label:"1 hour"},
					{value:10, label:"10 days"},
					{value:20, label:"20 days"},
					{value:30, label:"30 days"},
					{value:60, label:"60 days"},
					{value:90, label:"90 days"},
					{value:182, label:"6 months"},
					{value:365, label:"1 year"},
				]
				frm.dropDown($('.qualification_exp'), expOpt, descriptor.training.qualificationExp, {width:150}, function(v){
					descriptor.training.qualificationExp = v*1;
				} ).addClass('imgcls-dropdown-setup');

				$('#trainingQualificationExp').off('change').on('change', function(){
					descriptor.training.qualificationExp = $(this).val().trim()*1 || 0;
				}).val( descriptor.training.qualificationExp || 0);

				var typeOpt = [
					{value:1,label:'Training'},
					{value:3,label:'Qualification'},
				]
				frm.dropDown($('.qualification_type'), typeOpt, descriptor.training.type, {width:250,search:false}, function(v){
					descriptor.training.type = v*1;
					trainingCheck();
				} ).addClass('imgcls-dropdown-setup');

				// $('#trainingType').on('change', trainingCheck ).css({width:200}).val(descriptor.training.type||1);
				function trainingCheck(){
					var ttype = descriptor.training.type*1;
					if( ttype == 1 ) {
						$('.training-threshold').hide();
						$('#trainingtypepanel').hide();
					} else {
						$('.training-threshold').show();
						$('#trainingtypepanel').show();
					}
					// descriptor.training.type = ttype;
				}
				$('#trainingThreshold').off('change').on('change', function(){
					descriptor.training.threshold = $(this).val()*1 || 0;
					$('#trainingThreshold').val( descriptor.training.threshold )
				}).val(descriptor.training.threshold || 0)
				trainingCheck();
				window.uploadButton( $('#trainingsop'), '.pdf', function(d, fname){
					frm.myAlert( 'Uploading', 'Uploading SOP File, please wait.' );
					window.post('upload_project_file', {
						project: window.GlobalVars.PDFProjectId,
						fileName: 'SOP.pdf',
						fileData: d,
					}, res => {
						var data = res.data;
						// console.log( 'UPLOAD', data )
						frm.myAlertClose( function(){
							$('#trainingsopFileName').html( '<a href="'+data.url+'" target="_blank">'+fname+'</a>' ).off('click')
							descriptor.training.newSopFileName = fname;
						})
					})
				});
				window.uploadButton( $('#trainingmanual'), '.pdf', function(d, fname){
					frm.myAlert( 'Uploading', 'Uploading Manual File, please wait.' );
					window.post('upload_project_file', {
						project: window.GlobalVars.PDFProjectId,
						fileName: 'MANUAL.pdf',
						fileData: d,
					}, res => {
						var data = res.data;
						// console.log( 'UPLOAD', data )
						frm.myAlertClose( function(){
							$('#trainingmanualFileName').html( '<a href="'+data.url+'" target="_blank">'+fname+'</a>' ).off('click')
							descriptor.training.newManualFileName = fname;
						})
					})
				});
				window.post('get_project_file',{project: window.GlobalVars.PDFProjectId}, res => {
					var files = res.data;
					console.log( 'FILES', files )
					for( var f of files ) {
						$('#training'+f.var).html( '<a href="'+f.url+'" target="_blank">'+f.name+'</a>' )
					}
				})
			}
			else {
				function minConsensus(){
					$('#minConsensusAnnotators').html('');
					var olist = '';
					var ini = descriptor.annotatorsPerTask & 1 ? 3 : 2;
					if( descriptor.annotatorsPerTask == 1) ini = 1;
					for( var i = ini ; i <= descriptor.annotatorsPerTask ; i+=2 ) {
						olist += '<option>' + i + '</options>';
					}
					$('#minConsensusAnnotators').html(olist);
					$('#minConsensusAnnotators').val(descriptor.minConsensusAnnotators || ini)
					if( !$('#minConsensusAnnotators').val() ) $('#minConsensusAnnotators').val(ini)
					$('.consensus-mode-options')[$('#consensusMode').val()>0 ? 'show': 'hide']()
					$('.disableQC')[$('#consensusMode').val()>0 ? 'hide': 'show']()
					var cmode = $('#consensusMode').val() || 0;
				}
				$('#minConsensusAnnotators').val(descriptor.minConsensusAnnotators || 1)
				$('#consensusMode').val(descriptor.consensusMode || 0).css({width:300})
				$('#consensusThreshold').val(descriptor.consensusThreshold || '')
				$('.page-attributes-div').hide();
				$('.attributes-section').hide();
				$('.project-aws').hide();
				$('.project-annotators-per-task').show();
				$('#annotatorsPerTask').css({width:'auto'}).off('change').on('change', function(){
					var n = $(this).val();
					if( n*1 != descriptor.annotatorsPerTask*1) {
						descriptor.annotatorsPerTask = n;
						minConsensus()
						setTimeout( initPanel2, 1 );
					}
				});
				$('#consensusMode').off('change').on('change', minConsensus )
				minConsensus();
				$('.consensus-mode').show();
			}
			$('.maximum-concurrent').find('h1').html('Number of items per bulk task');
			$('#annotatorMaxTask').html('').css({ width: 'auto' });
			
			var mult = 10;
			for (var i = 1; i <= 100; i++) {
				$('#annotatorMaxTask').append($('<option>' + (i * mult) + '</option>'))
			}
		}
		$('#annotatorMaxTask').val(descriptor.annotatorMaxTask || mult)

		if (projectType == 'Media Transcription' || projectType == 'Code Switching') {
			$('.media-segmentation-section').show()
	
			descriptor.hasMediaSegmentation = exists(descriptor.segmentation);
			frm.booleanList($('.media-segmentation-bool'), descriptor, {
				items: {
					'hasMediaSegmentation': { default: false, label: 'Enable Media Segmentation' },
				},
				callbackOnInit: true,
			}, function (o) {
				setDescriptor(o);
				setTimeout(function () {
					$('.media-segmentation-attributes')[o.hasMediaSegmentation ? 'show' : 'hide']();
				}, 1);
			});
	
			if(projectType == 'Code Switching'){
				frm.optionList($('.media-segmentation-attributes'), frm.arr2Obj(descriptor.segmentation, 'name'), {
				fields: {
					'name': { type: 'text', placeholder: 'Enter Segmentation', label: 'Label' },
					'optional': { type: 'boolean', label: 'Optional', forceWidth: 100 },
					'DropDown': { type: 'boolean', label: 'DropDown', forceWidth: 100 },
					'options': { type: 'list', label: 'Options', placeholder: 'Enter Options' },
					'Primary Type': { type: 'list', label: 'Primary Type', placeholder: 'Enter Drop Down Options' },
					'Loudness Level': { type: 'list', label: 'Loudness Level', placeholder: 'Enter Drop Down Options' },
					'Transcription Inline': { type: 'list', label: 'Transcription Inline Only', placeholder: 'Enter Drop Down Options' }
				},
				defaultField: 'options',
				subLabels: false,
				maxSubLabels: 0,
				initValues: 8,
			}, function (o) {
				descriptor.segmentation = frm.obj2Arr(o, 'name');
			});
			}
			else if(projectType == 'Media Transcription'){
			frm.optionList($('.media-segmentation-attributes'), frm.arr2Obj(descriptor.segmentation, 'name'), {
				fields: {
					'name': { type: 'text', placeholder: 'Enter Segmentation', label: 'Label' },
					'optional': { type: 'boolean', label: 'Optional', forceWidth: 100 },
					'allowNew': { type: 'boolean', label: 'Allow New', forceWidth: 100 },
					'editable': { type: 'boolean', label: 'Editable', forceWidth: 100 },
					'options': { type: 'list', label: 'Options', placeholder: 'Enter Options' },
				},

				defaultField: 'options',
				subLabels: false,
				maxSubLabels: 0,
				initValues: 8,
			}, function (o) {
				descriptor.segmentation = frm.obj2Arr(o, 'name');
			});}
		}
		else $('.media-segmentation-section').hide()
		// if(projectType == 'AmEx Audio Templete') {

		// }
		console.log('desp', descriptor)
	
		descriptor.hasAttributes = exists(descriptor.attributes);
		console.log('despy', descriptor)

		frm.booleanList( $('.project-attributes-bool'), descriptor, {
			items: {
				'hasAttributes': { default: false, label: 'Enable Project Attributes' },
			},
			callbackOnInit: true,
		}, function(o){
			setDescriptor(o);
			setTimeout( function(){
				$('.project-attributes')[o.hasAttributes ? 'show':'hide']();
			}, 1 );
		} );
	
		frm.optionList( $('.project-attributes'), frm.arr2Obj(descriptor.attributes, 'label'), {
			fields: {
					'label': { type:'text', placeholder:'Enter Attribute',label:'Label'},
					'optional': { type: 'boolean', label: 'Optional', forceWidth: 100 },
					'allowNew': { type: 'boolean', label: 'Allow New', forceWidth: 100 },
					'options': { type:'list',label:'Options',placeholder:'Enter Options'},
			},
			defaultField:'options',
			subLabels: false,
			maxSubLabels: 0,
			initValues: 8,
		}, function(o){
			descriptor.attributes = frm.obj2Arr( o, 'label' );
		} );
	
		frm.optionList($('.project-metadata'), frm.vals2Obj(descriptor.metadata, 'value'), {
			fields: {
				'label': { type: 'text', placeholder: 'Enter label', label: 'Label' },
				'value': { type: 'text', placeholder: 'Enter value', label: 'Value' },
			},
			defaultField: 'value',
			subLabels: false,
			maxSubLabels: 0,
			callbackOnInit: true,
		}, function (o) {
			descriptor.metadata = frm.obj2Vals(o, 'value');
		});
	
		frm.booleanList( $('.project-aws-bool'), descriptor, {
			items: {
				'hasAWSCredentials': { default: false, label: 'Enable AWS Credentials' },
			},
			callbackOnInit: true,
		}, function(o){
			setDescriptor(o);
			setTimeout( function(){
				$('.project-aws-panel')[o.hasAWSCredentials ? 'show':'hide']();
				$('#awstype').off('change').on('change', awsTypeChange )
				awsTypeChange();
			}, 1 );
		} );
	
		frm.booleanList( $('.project-webhook-bool'), descriptor, {
			items: {
				'enableWebhooks': { default: false, label: 'Enable Webhooks' },
			},
			callbackOnInit: true,
		}, function(o){
			setDescriptor(o);
			setTimeout( function(){
				$('.project-webhook-panel')[o.enableWebhooks ? 'show':'hide']();
			}, 1 );
		} );
	
	// Taxonomy Section - Only for Code Switching projects
	function initTaxonomySection() {
    // --- 1. Initial State Setup ---
    if (!descriptor.labelForTagging) {
        descriptor.labelForTagging = null;
    }

    // Show/hide the entire section based on the project type.
    if (projectTypeCk('Code Switching')) {
        $('.project-taxonomy-section').show();
    } else {
        $('.project-taxonomy-section').hide();
        return; // Exit if the section is not needed for this project type.
    }

    // --- 2. Event Handlers ---
    $('#uploadTaxonomyBtn').off('click').on('click', function() {
        $('#taxonomyFileInput').click();
    });

    $('#taxonomyFileInput').off('change').on('change', function(e) {
        var file = e.target.files[0];
        if (!file) return;

        // Reset the input value so the 'change' event fires even if the same file is selected again.
        $(this).val(''); 

        if (!file.name.endsWith('.json')) {
            frm.myAlert('Invalid File Type', 'Please select a valid .json file for the taxonomy.');
            return;
        }

        var reader = new FileReader();
        reader.onload = function(event) {
            try {
                var jsonData = JSON.parse(event.target.result);
                
                // Validate the JSON using our improved function.
                const validation = validateTaxonomyStructure(jsonData);
                if (!validation.isValid) {
                    // Use frm.myAlert to show specific validation errors.
                    frm.myAlert('Invalid Taxonomy Structure', validation.message);
                    return;
                }

                // If valid, store the data in the global descriptor.
                descriptor.labelForTagging = jsonData;
                
                // Update the UI to show the successful upload.
                $('#taxonomyFileName').text('File: ' + file.name).css('color', '#28a745'); // Green for success
                $('#taxonomyContent').text(JSON.stringify(jsonData, null, 2));
                $('#taxonomyPreview').show();
                
                console.log('Taxonomy uploaded and validated successfully:', descriptor.labelForTagging);

            } catch (error) {
                frm.myAlert('JSON Parsing Error', 'There was an error parsing the JSON file: ' + error.message);
                console.error('JSON parse error:', error);
            }
        };
        reader.readAsText(file);
    });

    // --- 3. Display Previously Loaded Taxonomy ---
    // This runs on initial load to show data that might already be in the descriptor.
    if (descriptor.labelForTagging) {
        const validation = validateTaxonomyStructure(descriptor.labelForTagging);
        if (validation.isValid) {
            $('#taxonomyFileName').text('Taxonomy loaded').css('color', '#333');
            $('#taxonomyContent').text(JSON.stringify(descriptor.labelForTagging, null, 2));
            $('#taxonomyPreview').show();
        } else {
             // If the stored data is somehow invalid, notify the user.
             $('#taxonomyFileName').text('Stored taxonomy is invalid. Please re-upload.').css('color', '#dc3545'); // Red for error
             descriptor.labelForTagging = null;
        }
    } else {
        $('#taxonomyFileName').text('No taxonomy loaded.');
    }
}
	
	// Call initTaxonomySection to initialize and bind handlers
	initTaxonomySection();

	// Helper function to validate taxonomy structure
	function validateTaxonomyStructure(data) {
    if (!Array.isArray(data)) {
        return { isValid: false, message: 'The root of the taxonomy JSON must be an array of tag objects, like: [ ... ].' };
    }

    // A recursive helper function to check each node and its children.
    function checkNode(node, path) {
        // --- THIS IS THE KEY CHANGE ---
        // We now check for the fields required by the annotation tool: id, name, and color.
        const requiredFields = { id: 'string', name: 'string', color: 'string' };

        for (const field in requiredFields) {
            if (typeof node[field] !== requiredFields[field] || !node[field].trim()) {
                return { 
                    isValid: false, 
                    message: `A tag at path '${path}' is missing a valid, non-empty '${field}' property.` 
                };
            }
        }
        
        // Your original validation for children and output remains useful.
        if (node.hasOwnProperty('children')) {
            if (!Array.isArray(node.children)) {
                return { isValid: false, message: `The 'children' property at path '${path}' must be an array.` };
            }
            // Recursively validate each child.
            for (var child of node.children) {
                const result = checkNode(child, `${path} -> ${child.name || '(unnamed)'}`);
                if (!result.isValid) {
                    return result; // Immediately return the first error found.
                }
            }
        }

        // Validate the 'output' structure if it exists.
        if (node.hasOwnProperty('output')) {
            if (typeof node.output !== 'object' || node.output === null || !node.output.hasOwnProperty('start') || !node.output.hasOwnProperty('end')) {
                return { isValid: false, message: `The 'output' object for tag '${path}' is malformed. It must contain 'start' and 'end' properties.` };
            }
        }

        return { isValid: true, message: 'Valid' };
    }

    // Validate all root-level nodes in the array.
    for (var node of data) {
        const result = checkNode(node, node.name || '(unnamed root tag)');
        if (!result.isValid) {
            return result; // Return the first error found.
        }
    }

    return { isValid: true, message: 'Structure is valid.' };
}

	setTimeout( function(){
		origDescriptor = clone(descriptor);
	}, 100 );
	}
}

var descriptorCore = [
	'allowTextOffset',
	'allowTextMode',
	'allowTableMode',
	'allowAdjudication',
	'exportAllPlainTextPages',
	'checkboxes_set',
	'labels',
	'relationships',
	'boxes',
	'attributes',
	'pageAttributes',
	'classification',
	'metadata',
	'models',
	'exportAllPlainTextPages',
	'disableOverlap',
	'disableQC',
	'qcMayRequestAdjustment',
	'minConsensusAnnotators',
	'consensusMode',
	'consensusThreshold',
	'annotatorsPerTask',
	'annotatorMaxTask',
	'exportFormat',
	'allowLabelInput',
	'training',
	'questions',
	'requestTextHighlight',
];

function descriptorChanged()
{
    window.origDescriptor = origDescriptor;
    window.descriptor = descriptor;
    for( var i = 0 ; i < descriptorCore.length ; i++ )
    {
        var d = descriptorCore[i];
        if( JSON.stringify(descriptor[d]) != JSON.stringify(origDescriptor[d]) )
            return true;
    }
    return false;
}

window.descriptorChanged = descriptorChanged;

var PDFProjectId = null;
var projectName = '';
var projectDescription = '';
var projectType = null;
var projectTypeCheck = null;
var projectActive = false;
var projectTraining = false;
var projectDelete = false;
var projectCompany = null;
var currentMode = 0;

function projectTypeCk( p ) {
	for( var t of arguments ) {
		// console.log( 'checking', projectType, t )
		if( projectType == t ) return true;
	}
	return false;
}

function NlpImport(prop) {
	window.getParams();

    var projects = {};
    var pdfs = [];
	var keepDocs = false;

    function saveProject( callback, noredir )
    {
		frm.removeInlineErrors() // added 19/1 mani
        // if( !pdfs.length && !keepDocs ) return frm.myAlert( 'Save Project', 'Please import files by loading a valid manifest', 'Ok' );
        // if( !descriptor ) return frm.myAlert( 'Save Project', 'Please import a valid descriptor', 'Ok' );
        if( !projectName || projectName.trim() == '' )
        {
			return frm.inlineError($('#projectname'),'Please choose a name for the project')// added 19/1 mani
            // return frm.myAlert( 'Save Project', 'Please choose a name for the project', 'Ok', function(){ $('.project-name')[0].focus()} );
        }
		else if( !projectTypeCheck || projectTypeCheck.trim() == '' )
			{
				return frm.inlineError($('#projecttypecheck'),'Please choose a name for the project type')
				
			}
		else if( !projectType || projectType.trim() == '' )
			{
				return frm.inlineError($('#projecttype'),'Please choose a name for the category type')
			
			}
		if( descriptor.hasAWSCredentials )
		{
			descriptor.awsCredentials = {
				awsType: $('#awstype').val().trim(),
				awsRoleArn: $('#awsrolearn').val().trim(),
				awsExternalId: $('#awsexternalid').val().trim(),
				// awsRoleSessionName: $('#awsrolesessionname').val().trim(),
				awsKey: $('#awskey').val().trim(),
				awsSecret: $('#awssecret').val().trim(),
				awsRegion: $('#awsregion').val().trim(),

			}
			descriptor.s3IntermediateUrl = $('#awsintermediatepath').val().trim();
			// alert( descriptor.awsCredentials.awsType )
			if( descriptor.awsCredentials.awsType == 'key') {
				if( !descriptor.awsCredentials.awsKey ) return frm.inlineError($('#awskey'),'You must set the AWS Access Key')// added 19/1 mani
				// return frm.myAlert( 'Save Project', 'You must set the AWS Access Key', 'Ok', function(){ $('#awskey')[0].focus()} );
				if( !descriptor.awsCredentials.awsSecret ) return frm.inlineError($('#awssecret'),'You must set the AWS Secret')// added 19/1 mani
				// return frm.myAlert( 'Save Project', 'You must set the AWS Secret', 'Ok', function(){ $('#awssecret')[0].focus()} );
				if( !descriptor.awsCredentials.awsRegion ) return frm.inlineError($('#awsregion'),'You must set the AWS region')// added 19/1 mani
				//  return frm.myAlert( 'Save Project', 'You must set the AWS region', 'Ok', function(){ $('#awsregion')[0].focus()} );
			}
			else if( descriptor.awsCredentials.awsType == 'role') {
				if( !descriptor.awsCredentials.awsRoleArn ) return frm.inlineError($('#awsrolearn'),'You must set the AWS Role ARN')// added 19/1 mani
				//  return frm.myAlert( 'Save Project', 'You must set the AWS Role ARN', 'Ok', function(){ $('#awsrolearn')[0].focus()} );
				if( !descriptor.awsCredentials.awsExternalId ) return frm.inlineError($('#awsexternalid'),'You must set the AWS External Id')// added 19/1 mani
				// return frm.myAlert( 'Save Project', 'You must set the AWS External Id', 'Ok', function(){ $('#awsexternalid')[0].focus()} );
			}
			if( !descriptor.s3IntermediateUrl ) return frm.inlineError($('#awsintermediatepath'),'You must select a intermediate bucket path')// added 19/1 mani
			//  return frm.myAlert( 'Save Project', 'You must select a intermediate bucket path', 'Ok', function(){ $('#awsintermediatepath')[0].focus()} );

			// alert( descriptor.s3IntermediateUrl )
		}
		else {
			// delete descriptor.awsCredentials;
			descriptor.awsCredentials = null;
			descriptor.s3IntermediateUrl = null;
		}
		if( descriptor.enableWebhooks )
		{
			descriptor.webhooks = {
				taskUpdate: $('#taskwebhook').val().trim(),
				projectUpdate: $('#projectwebhook').val().trim(),
			}
		}
		else delete descriptor.webhooks;

		if( projectTypeCk('NER','TEXT_QA','Content Generation') ) {
			descriptor.wordPageBreak = $('#wordPageBreak').val() || 250;
		}

		descriptor.annotatorsPerTask = $('#annotatorsPerTask').val() || 1;
		descriptor.consensusMode = $('#consensusMode').val() || 0;
		descriptor.consensusThreshold = $('#consensusThreshold').val() || 0;
		descriptor.minConsensusAnnotators = $('#minConsensusAnnotators').val() || descriptor.annotatorsPerTask;
		descriptor.consensusMode = $('#consensusMode').val() || 0;
		descriptor.consensusThreshold = $('#consensusThreshold').val() || '';
		descriptor.annotatorMaxTask = $('#annotatorMaxTask').val() || 1; 
		if ( projectTypeCk('Bulk Image Classification') && descriptor.annotatorMaxTask < 10 ) descriptor.annotatorMaxTask = 10;
		descriptor.exportFormat = $('#exportformat').val()*1;

		if( projectTraining ) descriptor.annotatorsPerTask = 10000;
		if( descriptor.prelabelModel && descriptor.prelabelModel.length ) {
			delete descriptor.useKeypairmodel;
			delete descriptor.useKeypairDic;
			delete descriptor.useTablemodel;
		}
		console.log('DESCRIPTOR', JSON.stringify(descriptor))
        // pdfs.forEach( p => {
        //     p.projectName = projectName;
        // });
		frm.loading('Saving project')
        window.post( 'save_project', {
			name:projectName,
			description:projectDescription,
			type:projectType,
			p_type:projectTypeCheck,
			id: PDFProjectId,
			company: projectCompany || window.GlobalVars.userCompany,
			keepDocs: keepDocs,
			pdfs:pdfs,
			descriptor:descriptor,
			active: projectActive,
			training: projectTraining,
			delete: projectDelete,
		}, function(res){
			
			if( !frm.resultCheck(res)) return (projectDelete = false);
			console.log( 'SAVE', res.data )
			frm.loadingOut();
			if( res.data.status === 0 ) return frm.myAlert( 'Project Save', res.data.value );
			window.GlobalVars.PDFProjectId = PDFProjectId;
			window.GlobalVars.PDFProjectName = projectName;
			window.GlobalVars.PDFProjectCompany = projectCompany;
			window.GlobalVars.PDFProjectActive = projectActive;
			window.GlobalVars.PDFProjectType = projectType;
			window.GlobalVars.PDFProjectTypeCheck = projectTypeCheck;


			if( !noredir ) {
				window.saveSession( function() {
					var params = window.getParams();
					params.name = projectName;
					window.setParams( params )
					if( callback ) return callback();
					
					window.goPage( 'nlpProjectBrowse', params );
				})
			}
			else {
				if( callback ) return callback();
			}
        });
    }

	function saveProjectActive()
	{
		projectActive = true;
		saveProject( function(){
			// window.GlobalVars.userProjectSelect = 1;
			// window.saveSession();
			window.goPage( 'nlpWorkers', window.getParams() );
		} );
	}

    function checkAnnotations()
    {
        var tags = {};
        var boxes = {};
        var links = {};
        pdfs.forEach( p => {
            if( p.annotations.tags )
            p.annotations.tags.forEach( t => {
                var tag = t.type;
                tags[tag] = 1;
                if( t.properties )
                {
                    t.properties.forEach( p => {
                        tags[tag+'|'+p] = 1;
                    })
                }
            })
            if( p.annotations.links )
            p.annotations.links.forEach( t => {
                var link = t.relationship;
                links[link] = 1;
            })
            if( p.annotations.boxes )
            p.annotations.boxes.forEach( t => {
                var box = t.type;
                boxes[box] = 1;
            })
        });
        function find( obj, val )
        {
            try {
                val = val.split('|');
                var v = val.shift();
                if( !obj[v] ) return false;
                if( val.length ) return find( obj[v].sublabels, val.join('|') );
                return true;
            }
            catch(e){ return false }
        }
        var colors = ['#000000'];
        var cidx = 0;
        var colorKey = {};
        function create( obj, val, color )
        {
            try {
                val = val.split('|');
                var v = val.shift();
                if( !color ) color = colorKey[v];
                if( !color ) color = colorKey[v] = colors[cidx++ % colors.length];
                if( !obj[v] )
                {
                    obj[v] = {color:color,sublabels:{}}
                    return true;
                }
                if( val.length ) return create( obj[v].sublabels, val.join('|'), color );
                return false;
            }
            catch(e){ return false }
        }
        var dlabels = clone(descriptor.labels);
        var drelationships = clone(descriptor.relationships);
        var dboxes = clone(descriptor.boxes);
        function check()
        {
            var ntags = 0;
            var nlinks = 0;
            var nboxes = 0;
            var totColors  = 0;
            for( var k in tags ){ if( k.indexOf('|') == -1 ) totColors++ }
            totColors += Object.keys(links).length + Object.keys(boxes).length;
            colors = frm.paletteWheel(totColors, 2); cidx = 0;
            var prevCount = Object.keys(descriptor.labels) + Object.keys(descriptor.relationships) + Object.keys(descriptor.boxes);
            var initColor = prevCount ? '#000000' : null;
            for( var k in tags ){ if( create( dlabels, k, initColor ) ) ntags++; }
            for( var k in links ){ if( create( drelationships, k, initColor ) ) nlinks++; }
            for( var k in boxes ){ if( create( dboxes, k, initColor ) ) nboxes++; }
            console.log( 'totColors', totColors, 'labels', ntags, 'relationships', nlinks, 'boxes', nboxes );
            return ntags+nlinks+nboxes;
        }
        function add()
        {
            descriptor.labels = dlabels;
            descriptor.relationships = drelationships;
            descriptor.boxes = dboxes;
            initPanel();
        }
        var c = check();
        if( c > 0 )
        {
            frm.myAlert( 'Annotations', 'There are ' + c + ' labels/relationships/boxes that are not curently in the descriptor. Do you want to add them?', 'Ok', add, 'Ignore' )
        }
        console.log( 'checkAnnotations', tags, links, boxes )
    }

    function processManifest( manifest )
    {
        function invalid(s)
        {
            if( !s ) s = 'Invalid Manifest File';
            pdfs = [];
            $('#manifest').html('<span className="import-error">'+s+'</span>');
        }
        try {
            projects = {};
            pdfs = [];
            var totAnnotations = 0;
            manifest.forEach( (m,midx) => {
                if( !(m.trim()) ) return;
                var d = JSON.parse(m);
                var keys = Object.keys(d);
                // find project id
                var metadata = {}
                var id = ''; keys.forEach(k => { if(k.match(/-metadata/)) id = k.split('-metadata')[0]; metadata = d[k]})
                // id = PDFProjectId;
				console.log( 'ID', id );
                var source = d['source-ref'];
                var annotations = [];
				if( id )
				{
					var alist = d[id].annotationsFromAllWorkers;
					alist.forEach( a => {
						var aobj = {workerId:a.workerId};
						var d = JSON.parse(a.annotationData.content).annotations;
						if( !d ) return;
						d = JSON.parse(d);
						if( d.tags ) aobj.tags = d.tags;
						if( d.links ) aobj.links = d.links;
						if( d.boxes ) aobj.boxes = d.boxes;
						if( d.attributes ) aobj.attributes = d.attributes;

						if( d.metadata ) aobj.metadata = d.metadata;
						if( d.metadata ) aobj.metadata = d.metadata;
						annotations.push(aobj);
					})
				}
                totAnnotations += annotations.length;
                var userId = annotations.length ? annotations[0].workerId : '';
                // var project = id;
                var project = PDFProjectId;

                var fileId = [project,midx].join('-');
                var pdf = {
                    project:project,
					projectName:projectName,
					projectDescription:projectDescription,
                    fileId: fileId,
                    source:source,
                    userId: '-',
					company: projectCompany || window.GlobalVars.userCompany,
					qcId: '',
                    metadata: metadata,
                    annotations: annotations[0] || '',
                    num_annotations: annotations.length,
					state: annotations[0] && Object.keys(annotations[0]).length > 1 ? 2 : 0,
                    num_qc: 0,
					active: true,
                };
                // console.log( 'id', id, 'source', source, 'annotations', annotations );
                // console.log( 'AAAAAAAAAAAAAA', id, pdf, annotations[0], annotations[0].content );
                pdfs.push(pdf);
            });

            pdfs.forEach( p => {
                projects[p.project] = 1;
            });
            if( Object.keys(projects).length > 1 ) return invalid('All PDFs in the manifest must belong to the same project');

			function finish()
			{
				var sum = [pdfs.length, 'files', totAnnotations, 'annotations'].join(' ');
				$('.project-files').html('<b>Project Documents:</b> ' + pdfs.length );
				keepDocs = false;
				return frm.myAlert( 'Import Files', pdfs.length + ' documents imported', 'Ok', checkAnnotations );
			}
			function clearAnnotations()
			{
				pdfs.forEach( p => {
					p.annotations = [];
					p.userId = '';
					p.state = 0;
				} );
				finish();
			}
			if( totAnnotations )
				return frm.myAlert( 'Import Files', 'The imported documents have annotations. Do you want to import them?', 'Import Annotations', finish, 'Ignore Annotations', clearAnnotations );
			else
				finish();
        } catch(e)
        {
            console.error(e)
            invalid();
        }
    }

    function processDescriptor( desc )
    {
        function invalid()
        {
            // descriptor = {};
            $('#descriptor').html('<span className="import-error">Invalid Descriptor JSON File</span>');
        }
        try {
            var desc = JSON.parse(desc);
            // delete descriptor.pdf;
            // delete descriptor.text_attributes;
            // delete descriptor.adjudication_attributes;
            if( !desc.labels && !desc.boxes && !desc.classification   ) return invalid();

			if( projectTraining ) {
				if( desc.training ) {
					delete desc.training.sopFileName;
					delete desc.training.manualFileName;
					desc.annotatorsPerTask = 100000;
				}
			}
			else delete desc.training;
            function setDescriptor()
            {
                console.log( 'DESC', clone(desc) );
                descriptorCore.forEach( f => {
                    if( desc[f] ) {
						console.log( '-----------------> ', f, desc[f] )
						descriptor[f] = desc[f];
						try {

						} catch(e) { console.log(e) };
						if( $('#'+f).length ) {
							$('#'+f).val( desc[f] )
						}
					}
                });
				console.log( 'LOADED', clone(descriptor))
                initPanel();
                checkAnnotations();
            }
            if( !descriptorChanged() ) return setDescriptor();
            frm.myAlert( 'New Descriptor', 'This will overide current descriptor values. Proceed?', 'Overide', setDescriptor, 'Cancel');
        } catch (e) {
            return invalid();
        }
    }

    function exportDescriptor( ev )
    {
        ev.preventDefault();
        var blob = new Blob([JSON.stringify(descriptor,null,'\t')], {type: "text/plain;charset=utf-8"});
        var url = window.URL.createObjectURL(blob);

        var a = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = url;
        a.setAttribute("download","descriptor.json");
        a.click();
        window.URL.revokeObjectURL(url);
    }

	function wizzSaveCancel()
	{

		if( projectActive )
		{
			$('.wizzbtn').html('<button id="cancelbtn" class="btn btn-secondary mr-2"><i class="fa fa-times-circle mr-2" aria-hidden="true"></i>Cancel</button><button id="savebtn" class="btn btn-pink mt-0"><i class=" mr-2 fa fa-floppy-o"></i>Save</button><button id="deletebtn" class="btn btn-danger ml-2"><i class="fa fa-trash-o mr-2"></i>Delete</button>');
			$('#cancelbtn').on('click', function(){
				window.goPage( window.projectWizzard[0], window.getParams() );
			})

			$('#savebtn').on('click', function(){

				if(window.GlobalVars.PDFProjectType === "TEXT_QA" || window.GlobalVars.PDFProjectType === "Content Generation"){
					var CheckQAMandatory = CheckQA();
					if(!CheckQAMandatory){
						return false; 
					}
				}
				saveProject( function(){
					window.goPage( window.projectWizzard[window.projectWizzard.length-1], window.getParams() );
				})
			})
			$('#deletebtn').on('click', function(){
				return frm.myAlert( 'Delete Project', 'Do you really want to delete this project?<br><b>This action cannot be undone.</b>', 'Delete Project', function(ev){
					projectActive = false;
					projectDelete = true;
					saveProject(function () {
						window.GlobalVars.userProjectSelect = 0;
						window.GlobalVars.PDFProjectId = null;
						window.saveSession(function () {
							// window.goPage( window.projectWizzard[0] );
							window.goPage('nlpProjectBrowse', window.getParams())
						})
					}, 1 )
				}, 'Cancel' );
			})
			if( currentMode != 3 ) $('#deletebtn').hide();
			return;
		}
		var save = currentMode == 3 ? saveProjectActive : saveProject;
		window.wizzardBar(true)
		window.wizzardButtons( $('.wizzbtn'), save )
		window.topBarVisible()
	}

    function initProject()
    {
		projectType = window.GlobalVars.PDFProjectType || 'NER';
		projectTypeCheck = window.GlobalVars.PDFProjectTypeCheck ;
		var pageId = (window.GlobalVars.pageMenu && window.GlobalVars.pageMenu.id) || null;
		currentMode = pageId.match(/[0-9]$/)

		if( currentMode ) currentMode = currentMode[0]*1
		if( !currentMode ) currentMode = 1;
		console.log( 'PAGEID', pageId, currentMode )
		$('.project-files').hide();
		// $('#topbuttons').html('');

		if( 0 && window.hasPriv( 'admin', 'c_admin') )
		{
			var projBut = $('<Button id="browseProjects" variant="primary" type="submit" class="mt-2 btn btn-primary">Back to Projects</Button>')
			projBut.on('click', () => {
				window.GlobalVars.PDFProjectId = null;
				window.GlobalVars.PDFFileId = null;
				window.saveSession();
				window.goPage('nlpProjectBrowse', window.getParams());
			})
			$('#topbuttons').append(projBut);
		}

		PDFProjectId = window.GlobalVars.PDFProjectId || window.createId();
		if( !window.GlobalVars.PDFProjectCompany ) window.GlobalVars.PDFProjectCompany = window.GlobalVars.userCompany;
	// $('#pageTitle').text( window.GlobalVars.PDFProjectId ? 'Edit PDF Project - ' + window.GlobalVars.PDFProjectName : 'Create New PDF Project');
        projects = {};
        pdfs = [];
        descriptor = { projectId: PDFProjectId };
        $('#manifest').html('(no dataaaa)');
        $('#descriptor').html('(no data)');
        window.uploadButton( $('#loadprojec'), '.manifest', function(d){
            var manifest = atob(d);
            manifest = manifest.split('\n');
            window.manifest = manifest;
            processManifest( manifest );
        });

        $('#import').unbind('click').on('click', saveProject );
        $('#exportdescriptor').unbind('click').on('click', exportDescriptor );
        // $('.project-files').html('<b>Project Files:</b> ' + pdfs.length );

		if( window.GlobalVars.PDFProjectId )
		{
			var match = {id:PDFProjectId};
			window.post( 'find_projects', {match:match}, function(res){
				if( res.data.count != 1 ) return;
			 	project = res.data.records[0];
				console.log( 'PROJECT', project );
				descriptor = project.descriptor;
				projectName = project.name;
				projectDescription = project.description;
				projectCompany = project.company;
				// projectActive = project.active;
				projectTraining = project.training;
				projectActive = project.active || false;
				projectType = project.type ;
				projectTypeCheck = project.p_type ;
				console.log( 'DESCRIPTOR', descriptor, 'projectTraining', projectTraining )

				if ((projectType == 'Media Transcription' || projectType == 'AmEx Audio Templete'|| projectType == 'Code Switching')&& currentMode == 2) {
					$(document.body).hide();
					projectActive = true;
					return setTimeout( saveProjectActive, 100 );
				}
				// $('.project-files').html('<b>Project Files:</b> ' + project.num_files );
				keepDocs = true;
				if( descriptor.hasAWSCredentials )
				{
					if( !descriptor.awsCredentials ) descriptor.awsCredentials = {awsType:'global'}
					// if( projectType != 'NER' ) $('#optrole').prop('disabled',true)
					$('#awstype').val(descriptor.awsCredentials.awsType).off('change').on('change', awsTypeChange )
					$('#awsrolearn').val(descriptor.awsCredentials.awsRoleArn)
					$('#awsexternalid').val(descriptor.awsCredentials.awsExternalId)
					// $('#awsrolesessionname').val(descriptor.awsCredentials.awsRoleSessionName)
	
					$('#awskey').val(descriptor.awsCredentials.awsKey)
					$('#awssecret').val(descriptor.awsCredentials.awsSecret)
					$('#awsregion').val(descriptor.awsCredentials.awsRegion)
					// $('#awsintermediatepath').val(descriptor.s3IntermediateUrl)
					$('#awsintermediatepath').val(descriptor.s3IntermediateUrl);
					awsTypeChange();
				}
				if( descriptor.enableWebhooks )
				{
					$('#taskwebhook').val(descriptor.webhooks.taskUpdate)
					$('#projectwebhook').val(descriptor.webhooks.projectUpdate)
				}
				$('#wordPageBreak').val( descriptor.wordPageBreak || 250 );
				$('#annotatorsPerTask').val(descriptor.annotatorsPerTask || 1);
				$('#minConsensusAnnotators').val(descriptor.minConsensusAnnotators || 1);
				$('#annotatorMaxTask').val(descriptor.annotatorMaxTask || 1);
				// $('#exportformat').css({width:250});
				if( projectTypeCk('Comprehend NER') ) {
					$('#exportformat').html('');
					$('#exportformat').append( $('<option value="0">Comprehend Format Full</option>') );
					$('#exportformat').append( $('<option value="2">Comprehend Format with linked Blocks</option>') );
					$('#exportformat').append( $('<option value="1">ADL Bounding Box Format</option>') );
				}
				if( projectTypeCk('OCR') || projectTypeCk('Pose Estimation' || projectTypeCk('Segmentation') || projectTypeCk('Key Point')) ) {
					$('.type-format').hide()
				}
				$('#exportformat').val(descriptor.exportFormat || 0);

				if( project.states && Object.keys(project.states).filter( s => s > 0).length ) {
					var cls = ['.project-annotators-per-task', '.consensus-mode'];
					for( var c of cls ) {
						$(c).find('input').each( function(edx,el) {
							$(el).attr('disabled', true);
						})
						$(c).find('select').each( function(edx,el) {
							$(el).attr('disabled', true);
						})
					}
				}


				wizzSaveCancel();
				initPanel();
				// var annotations = [];
				// var results = $('#results').html('');
				// console.log( 'PROJECTS', projects );
				// if( !projects.length )
				// {
				// 	$('.alert').remove();
				// 	var empty = $('<div role="alert" class="fade alert alert-danger show">').html('No projects found');
				// 	$('#topbuttons').prepend(empty);
				// }
				// projects.forEach( p => {
				// 	addProject( results, p );
				// })
			});
		}
        else
		{
			wizzSaveCancel();
			initPanel();
		}
		if (currentMode) {
			var hideClass = {
				'NER': ['type-Classification','type-Transcription','type-OCR', 'project-aws-credentials'],
				'Comprehend NER': ['type-Classification','type-Transcription', 'project-aws-credentials', 'type-format'],
				'OCR': ['type-Classification','type-Transcription','type-Format', 'project-aws-credentials'],
				'TEXT_QA': ['panel-autolabel', 'type-NER', 'type-Classification','type-Transcription','type-OCR', 'project-aws-credentials'],
				'Content Generation': ['panel-autolabel', 'type-NER', 'type-Classification','type-Transcription','type-OCR', 'project-aws-credentials'],
				'Pose Estimation': ['type-Classification','type-Transcription', 'project-aws-credentials'],
				'Classification': ['type-NER','type-Transcription','type-OCR', 'project-aws-credentials'],
				'Media Transcription': ['type-NER','type-Classification','type-OCR', 'project-aws-credentials'],
				'AmEx Audio Templete': ['type-NER','type-Classification','type-OCR', 'project-aws-credentials','project-aws'],
				'Code Switching': ['type-NER','type-Classification','type-OCR', 'project-aws-credentials','project-aws'],
				'Bulk Image Classification': ['type-Transcription','type-Classification','type-OCR','attributes-section','page-attributes-div','type-format', 'project-aws'],
				'Segmentation': ['type-Classification','type-Transcription', 'project-aws-credentials'],
				'Key Point': ['type-Classification','type-Transcription', 'project-aws-credentials'],
				'Response Generation': ['type-NER','type-Classification','type-OCR', 'project-aws-credentials']
			}
			$('.noshow').hide();
			$('.step1').hide();
			$('.step2').hide();
			$('.step3').hide();
			$('.step' + currentMode).show();
			if( currentMode == 2 ) {
				$('#topbuttons').html('<button id="loaddescriptor" class="btn btn-pink mt-0 mr-2"><i class="fa fa-download mr-2"></i>Import Descriptor</button><button id="exportdescriptor" class="btn btn-pink mt-0 mr-2"><i class="fa fa-upload mr-2"></i>Export Descriptor</button>');
				window.uploadButton( $('#loaddescriptor'), '.json', function(d){
					processDescriptor( atob(d) );
				});
				$('#exportdescriptor').off('click').on('click', exportDescriptor );
			}
			for (var c of hideClass[projectType]) $('.' + c).hide();
			if( projectType == 'Media Transcription' || projectType == 'AmEx Audio Templete' || projectType == 'Code Switching') $('.attributes-section').show()
		}

    }

    $(function() {
      var loc = window.location.href; // returns the full URL
      if(/#Project%20Labels%20&%20Relationships/.test(loc)) {
        $('.wizzbtn').addClass('last_step_btns');
      }

	  $('#projecttypecheck').on('change', function(){
		var selectedType = $(this).val();
		projectTypeCheck = selectedType;
		var options = [];

		if(selectedType === "NLP") {
			options = [
				{value:'', text: ""},
				{text: 'Classification'},
				{text: 'NER'},
				{value: 'OCR', text: 'OCR'},
				{value: 'Comprehend NER', text: 'Comprehend NER'},
			];
		} else if(selectedType === "Computer Vision") {
			options = [
				{value: '', text: "" },
				{value: 'Pose Estimation', text: 'Bounding Box'},
				{value: 'Bulk Image Classification', text: 'Bulk Image Classification'},
				{text: 'Classification'},
				{value: 'Segmentation', text: 'Segmentation'},
				{value: 'Key Point', text: 'Key Point'},
				
			];
		} else if(selectedType === "Generative_ai") {
			options = [
				{value: '', text: ""},
				{value: 'TEXT_QA', text: 'Q&A'},
				{value: 'Content Generation', text: 'Content Generation'},
				{value: 'Response Generation', text: 'Response Generation'},	
			];
		} else if(selectedType === "Audio" ) {
			options = [
				{value: '', text: ""},
				{value:'Media Transcription', text: 'Media Transcription'},
				{value:'AmEx Audio Templete', text: 'AmEx Audio Templete'},
				{value:'Code Switching', text: 'Code Switching'},
				
			];

		}else if(selectedType === "Video" ) {
			options = [
				{value: '', text: ""},
				{value:'Media Transcription',text: 'Media Transcription'},
				
			];

		}
		
		// Clear and hide the second select if no valid type is selected
		if(options.length === 0) {
			$('#projecttype').hide();
		} else {
			$('#projecttype').empty().show();
			options.forEach(function(option) {
				$('#projecttype').append($('<option>', { 
					value: option.value,
					text : option.text 
				}));
			});
		}
			});

			});

    useEffect( function(a){
        initProject();
		frm.convertSelects($('select'));
		if( window.GlobalVars.PDFProjectType == 'Pose Estimation' || window.GlobalVars.PDFProjectType == 'Segmentation' || window.GlobalVars.PDFProjectType == 'Key Point') {
			$('#exportformat').prop('disabled', true);
		}

    });

	//   sample project video 
	// const videos = {
	// 	'NER': 'https://docs.tensoract.com/_images/NER-Annotator-ScaleToFitVideo.gif',
	// 	'OCR': 'https://docs.tensoract.com/_images/OCR-Annotation-View.gif',
	// 	'Comprehend NER': 'https://docs.tensoract.com/_images/Comprehend-NER-Annotation.gif',
	// 	'TEXT_QA': 'https://docs.tensoract.com/_images/Q-A-ANNOTATOR-VIEW.gif',
	// 	'Classification': 'https://docs.tensoract.com/_images/Classification-Annotation-View.gif',
	// 	'Media Transcription': 'https://docs.tensoract.com/_images/Media-Transcription-Annotation.gif',
	// 	'Bulk Image Classification': 'https://docs.tensoract.com/_images/Bulk-Image-Annotation.gif',
	// 	'Pose Estimation': 'https://docs.tensoract.com/_images/Object-Detection-Annotation.gif',
	//   };
	
	//   useEffect(() => {
	// 	updateVideoDisplay('NER');
	
	// 	// Set up jQuery event handler for project type changes
	// 	$('#projecttype').on('change', function(ev) {
	// 	  const projectType = $(this).val().trim();
	// 	  updateVideoDisplay(projectType);
	// 	});
	
	// 	// Cleanup function to remove event listener
	// 	return () => {
	// 	  $('#projecttype').off('change');
	// 	};
	//   }, []);
	
	//   // Function to update video display
	//   const updateVideoDisplay = (projectType) => {
	// 	const videoContainer = $('.video-container');
	// 	const videoUrl = videos[projectType];
	
	// 	if (videoUrl) {
	// 	  videoContainer.empty(); // Clear existing content
	
	// 	  if (videoUrl.endsWith('.gif')) {
	// 		// Create and append img element for GIFs
	// 		const img = $('<img>', {
	// 		  src: videoUrl,
	// 		  width: 450,
	// 		  alt: 'Project animation'
	// 		});
	// 		videoContainer.append(img);
	// 	  } else {
	// 		// Create and append video element for MP4s
	// 		const video = $('<video>', {
	// 		  width: 450,
	// 		  controls: true,
	// 		  loop: true
	// 		});
	// 		const source = $('<source>', {
	// 		  src: videoUrl,
	// 		  type: 'video/mp4'
	// 		});
	// 		video.append(source);
	// 		videoContainer.append(video);
	// 	  }
	// 	} else {
	// 	  videoContainer.html('<p>Please select a project type to view the associated video.</p>');
	// 	}
	//   };
	

    return (
		<div fluid="md p-0" className="maincontent">
			<div className="row">
				<Col ssm={9} className="mt-3">
				<div className="wwizzbtn"></div>
					<div id="topbuttons" className="importexport"></div>
					<div className="project-panel panel_qa">					
					</div>
					<div className="project-panel">
						<div className="step1">
							<div className="project-name-div">
							{/* <button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapseThirty-Two" aria-expanded="true" aria-controls="collapseThirty-Two"> 
                           <i className="fa fa-chevron-down acc"></i>
						   </button>  */}
                            <div id="collapseThirty-Two" className="collapse show config" aria-labelledby="headingThirty-Two" >
								<div className="project-setup-div">
								<div id="projectid" className="project-id"></div>
								<label htmlFor="projectname">Project Name *</label>
								<input placeholder="Project Name" type="text" id="projectname" className="mb-4 form-control" />
								<label htmlFor="projectdescription">Project Description</label>
								<input placeholder="Description" type="text" id="projectdescription" className="mb-4 form-control" />
								{/* <label htmlFor="projecttype">Project Type *</label> */}
								{/* <select placeholder="Project Type" type="text" id="projecttype" className="mb-4 form-control">
									<option>NER</option>
									<option value="Comprehend NER">Comprehend NER (Experimental)</option>
									<option value="OCR">OCR</option>
									<option value="TEXT_QA">Q&A</option>
									<option>Classification</option>
									<option>Media Transcription</option>
									<option value="Bulk Image Classification">Bulk Image Classification</option>
									<option value="Pose Estimation">Object Detection</option>
								</select> */}
								<label htmlFor="projecttypecheck">Project Type *</label>
								<select
									placeholder="Project Type"
									type="text"
									id="projecttypecheck"
									className="mb-4 form-control"
								>
									 <option value=""></option>
									<option value="NLP">NLP</option>
									<option value="Computer Vision">Computer Vision</option>
									<option value="Generative_ai">Generative AI</option>
									<option value="Audio">Audio</option>
									<option value="Video">Video</option>
								</select>
								

								<label htmlFor="projecttype">Category Type *</label>

								<select placeholder="Category Type" type="text" id="projecttype" className="mb-4 form-control">
									<option value="">Category type</option>
								
								</select>
								
							 {/* sample video  */}
								{/* <div className="video-container project-video">  </div> */}
								<div className="trainckbox">
									<input type="checkbox" id="trainingproject" /> Training Project
								</div>
                             </div>
								</div>
							</div>
						</div>
						<div className="project-section project-settings step3">
							{/* <h1>Settings</h1> */}
							{/* <p className="project-files project-text step3 hidden"></p> */}
							{/* <div className="project-settings-bool step3"></div> */}
							{/* <div className="project-settings2-bool step3"></div> */}
        <button className=" btn-link bg-transparent btn-block text-left border-0 acc" type="button" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
		<h1>Settings</h1><i className="fa fa-chevron-down acc "></i>
        </button>
       <div id="collapseOne" className="collapse show" aria-labelledby="headingOne" >
                           <div className="project-settings-bool step3"></div>
							<div className="project-settings2-bool step3"></div>
                     </div>
						</div>
						<div className="step2 type-NER pre-label">
							<div className="project-section step2 panel-prelabel">
							<button className=" btn-link bg-transparent btn-block text-left acc border-0 " type="button" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="true" aria-controls="collapseTwo">
							<h1>Pre-Labeling Model</h1><i className="fa fa-chevron-down acc"></i>
        </button>
		<div id="collapseTwo" className="collapse show" aria-labelledby="headingTwo" >
							<div id="prelabelcontainer"></div>
								<div className="prelabeldetails">
									<h1>Batch minimum number of documents to invoke pre-labeling</h1>
									<select id="prelabeltasknum" className="mb-4 form-control" style={{ width: 150 }}>
										<option>10</option>
										<option>25</option>
										<option>50</option>
										<option>100</option>
										<option>150</option>
										<option>200</option>
										<option>250</option>
										<option>300</option>
										<option>400</option>
										<option>500</option>
									</select>
									<h1>Schedule pre-labeling every x mins for new uploaded documents</h1>
									<select id="prelabelschedule" className="mb-4 form-control" style={{ width: 150 }}>
										<option value="1">1 minute</option>
										<option value="2">2 minutes</option>
										<option value="5">5 minutes</option>
										<option value="10">10 minutes</option>
										<option value="20">20 minutes</option>
										<option value="30">30 minutes</option>
										<option value="40">40 minutes</option>
										<option value="50">50 minutes</option>
										<option value="60">60 minutes</option>
									</select>
								</div>

								<div className="panel-keypair">
								<h1>Table & Key/Value Detection</h1>
									<div>
										<div className="project-keypair-drop step2"></div>
										<div className="project-keypair-bool step2"></div>
									</div>
								</div>




								</div>
							</div>
						</div>
						<div className="step2 type-NER">
							<div className="project-section step2 panel-autolabel">
							<button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapseThree" aria-expanded="true" aria-controls="collapseThree">
							<h1>Auto Labeling Models</h1><i className="fa fa-chevron-down acc"></i>
							</button>
							<div id="collapseThree" className="collapse show" aria-labelledby="headingThree" >
								<div className="project-models-input step2"></div>
								<div className="project-models-bool step2"></div>
								</div>
							</div>
						</div>
						{/* <div className="step2 type-OCR">
							<div className="project-section step2 panel-keypair">
							<button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapseFour" aria-expanded="true" aria-controls="collapseFour">
							<h1>Table & Key/Value Detection</h1><i className="fa fa-chevron-down acc"></i></button>
							<div id="collapseFour" className="collapse show" aria-labelledby="headingFour" >
								<div className="project-keypair-drop step2"></div>
								<div className="project-keypair-bool step2"></div>
							</div>
							</div>
						</div> */}
						<div className="step2 type-NER">
							<div className="project-section panel-labels">
							<button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapseFive" aria-expanded="true" aria-controls="collapseFive">
							<h1>Labels</h1><i className="fa fa-chevron-down acc"></i></button>
							<div id="collapseFive" className="collapse show" aria-labelledby="headingFive" >
								<div className="project-labels-bool"></div>
								<div className="project-labels"></div>
							</div></div>	
							<div className="project-section panel-relationships">
							<button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapseSix" aria-expanded="true" aria-controls="collapseSix">
							<h1>Relationships</h1><i className="fa fa-chevron-down acc"></i></button>
							<div id="collapseSix" className="collapse show" aria-labelledby="headingSix" >
								<div className="project-relationships-bool"></div>
								<div className="project-relationships"></div>
							</div></div>	
							<div className="project-section panel-boxes">
							<button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapseSeven" aria-expanded="true" aria-controls="collapseSeven">
							<h1>Boxes</h1><i className="fa fa-chevron-down acc"></i></button>
							<div id="collapseSeven" className="collapse show" aria-labelledby="headingSeven" >
								<div className="project-boxes-bool"></div>
								<div className="project-boxes"></div>
							</div></div>
						</div>
						<div className="step2 type-Classification">
							<div className="project-section">
							<button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapseEight" aria-expanded="true" aria-controls="collapseEight">
							<h1>Classification Labels</h1><i className="fa fa-chevron-down acc"></i></button>
							<div id="collapseEight" className="collapse show" aria-labelledby="headingEight" >	
								<div id="classification-labels"></div>
							</div></div>
						</div>
						<div className="step2 project-panel instructions-panel">			
						</div>						
						<div className="step3">
							<div className="project-section project-word-page-break hidden">
							<button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapseNine" aria-expanded="true" aria-controls="collapseNine">
							<h1>Words per page (text files)</h1><i className="fa fa-chevron-down acc"></i></button>
							<div id="collapseNine" className="collapse show" aria-labelledby="headingNine" >	
								<div className="project-export-panel">
									<select id="wordPageBreak" className="mb-4 form-control">
										<option>50</option>
										<option>100</option>
										<option>150</option>
										<option>200</option>
										<option>250</option>
										<option>300</option>
										<option>400</option>
										<option>500</option>
										<option>750</option>
										<option>1000</option>
										<option>1250</option>
										<option>1500</option>
										<option>2000</option>
										<option>3000</option>
									</select>
								</div>
								</div>
							</div>							
							<div className="project-section project-annotators-per-task">
							<button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapseTen" aria-expanded="true" aria-controls="collapseTen">
							<h1>Annotators per task</h1><i className="fa fa-chevron-down acc"></i></button>
							<div id="collapseTen" className="collapse show" aria-labelledby="headingTen" >		
								<div className="project-export-panel">
									<select id="annotatorsPerTask" className="mb-4 form-control">
										<option>1</option>
										<option>2</option>
										<option>3</option>
										<option>4</option>
										<option>5</option>
										<option>6</option>
										<option>7</option>
										<option>8</option>
										<option>9</option>
									</select>
								</div></div>
							</div>
							<div className="project-section consensus-mode hidden">
							<button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapseEleven" aria-expanded="true" aria-controls="collapseEleven">
							<h1>Consensus Mode</h1><i className="fa fa-chevron-down acc"></i></button>
							<div id="collapseEleven" className="collapse show" aria-labelledby="headingEleven" >	
								<div className="project-export-panel">
									<select id="consensusMode" className="mb-4 form-control">
										<option value="0">No consensus mode</option>
										<option value="2">Min threshold, 2 reviewers</option>
									</select>
								</div>
								<div className="consensus-mode-options">
									<label htmlFor="consensusThreshold">Consensus Threshold</label>
									<input placeholder="Consensus Threshold %" type="text" id="consensusThreshold" className="mb-4 form-control" style={{ width: 200 }} />
									<label htmlFor="minConsensusAnnotators">Min annotators for consensus</label>
									<div className="project-export-panel">
										<select id="minConsensusAnnotators" className="mb-4 form-control">
											<option>2</option>
											<option>3</option>
											<option>4</option>
											<option>5</option>
											<option>6</option>
											<option>7</option>
											<option>8</option>
											<option>9</option>
										</select>
									</div>
								</div>
								</div>
							</div>

							{/* <div className="project-section min-consensus-annotators hhidden">

							</div> */}
							<div className="project-section project-aws maximum-concurrent">
							<button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapseTwelve" aria-expanded="true" aria-controls="collapseTwelve">
							<h1>Maximum concurrent tasks per annotator</h1><i className="fa fa-chevron-down acc"></i></button>
							<div id="collapseTwelve" className="collapse show" aria-labelledby="headingTwelve" >
								<div className="project-export-panel">
									<select id="annotatorMaxTask" className="mb-4 form-control">
										<option>1</option>
										<option>2</option>
										<option>3</option>
										<option>4</option>
										<option>5</option>
										<option>6</option>
										<option>7</option>
										<option>8</option>
										<option>9</option>
									</select>
								</div>
							</div></div>

							<div className="project-section  bookmark-reference hidden">
							<button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapseThirteen" aria-expanded="true" aria-controls="collapseThirteen">
							<h1>Dataset Reference Bookmark</h1><i className="fa fa-chevron-down acc"></i></button>
							<div id="collapseThirteen" className="collapse show" aria-labelledby="headingThirteen" >
								<div className="project-export-panel">
								<input placeholder="Enter Bookmark Url" type="text" id="bookmarkURL" className="mb-4 form-control" />
								</div>	
								</div>
							</div>

							<div className="project-section training-mode hidden">
							<button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapseFourteen" aria-expanded="true" aria-controls="collapseFourteen">
							<h1>Training Mode</h1><i className="fa fa-chevron-down acc"></i></button>
							<div id="collapseFourteen" className="collapse show" aria-labelledby="headingFourteen" >	
								{/* <br></br>  30/12 mani*/}
								<div className="flex mf">
									<div>
										<label htmlFor="trainingQualificationName">Badge Name</label>
										<div className="qualification"></div>
										{/* <input placeholder="Enter badge name" type="text" id="trainingQualificationName" className="mb-4 form-control" style={{ width: 200 }} /> */}
									</div>
									<div className="ml-2" id="trainingtypepanel">
										<label htmlFor="trainingType">Badge Expiration</label>
										<div className="qualification_exp"></div>
										{/* <select id="trainingQualificationExp" className="mb-4 form-control">
											<option value="0">Never</option>
											<option value="0.0416">1 hour</option>
											<option value="10">10 days</option>
											<option value="20">20 days</option>
											<option value="30">30 days</option>
											<option value="60">60 days</option>
											<option value="90">90 days</option>
											<option value="182">6 months</option>
											<option value="365">1 year</option>
										</select> */}
									</div>
								</div>
								<br></br>
								<div className="flex mt-2">
									<div>
										<div className="project-export-panel mt-1">	{/* modify mt-3 to mt-1 30/12  mani */}
											<label htmlFor="trainingType">Training type</label>
											<div className="qualification_type bp"></div>
											{/* <select id="trainingType" className="mb-4 form-control">
												<option value="1">Training</option>
												<option value="3">Qualification</option>
											</select> */}
										</div>
									</div>
									<div className="ml-2 mt-1">	{/* modify mt-3 to mt-1 30/12  mani */}
										<div className="training-threshold">
											<label htmlFor="trainingThreshold">Success Threshold</label>
											<input placeholder="Success Threshold %" type="text" id="trainingThreshold" className="mb-4 form-control" style={{ width: 150 }} />
										</div>
									</div>
								</div>
								<div className="mf">
									<div className="mt-1">{/* add class mt-1 30/12 mani */}
										<button id="trainingsop" className="btn btn-primary">Upload SOP File</button>
										<span id="trainingsopFileName" className="trainging-upload-file"></span>
									</div>
									<div className="mt-2 mb-3">
										<button id="trainingmanual" className="btn btn-primary">Upload Training Manual</button>
										<span id="trainingmanualFileName" className="trainging-upload-file"></span>
									</div>
								</div>
							</div></div>

							<div className="project-section">
							<button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapseFifteen" aria-expanded="true" aria-controls="collapseFifteen">
							<h1>Project Metadata</h1><i className="fa fa-chevron-down acc"></i></button>
								<div id="collapseFifteen" className="collapse show" aria-labelledby="headingFifteen" >	
								<div className="project-metadata"></div>
							</div></div>
							<div className="project-section type-NER page-attributes-div">
							<button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapseSixteen" aria-expanded="true" aria-controls="collapseSixteen">
							<h1>Page Attributes<span>required for each page</span></h1><i className="fa fa-chevron-down acc"></i></button>
							<div id="collapseSixteen" className="collapse show" aria-labelledby="headingSixteen" >
								<div className="page-attributes-bool"></div>
								<div className="page-attributes"></div>
								</div>
							</div>
							<div className="project-section project-taxonomy-section" style={{display: 'none'}}>
							<button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapseTaxonomy" aria-expanded="true" aria-controls="collapseTaxonomy">
							<h1>Taxonomy</h1><i className="fa fa-chevron-down acc"></i></button>
							<div id="collapseTaxonomy" className="collapse show" aria-labelledby="headingTaxonomy" >
								<div className="taxonomy-upload-controls" style={{padding: '10px'}}>
									<input type="file" id="taxonomyFileInput" accept=".json" style={{display: 'none'}} />
									<button id="uploadTaxonomyBtn" className="btn btn-primary" style={{padding: '8px 16px', backgroundColor: '#0066cc', color: 'white', border: 'none', borderRadius: '4px', cursor: 'pointer'}}>
										Upload Taxonomy
									</button>
									<span id="taxonomyFileName" style={{marginLeft: '15px', color: '#666'}}></span>
								</div>
								<div id="taxonomyPreview" style={{marginTop: '20px', padding: '15px', backgroundColor: '#f5f5f5', borderRadius: '4px', display: 'none'}}>
									<h3>Uploaded Taxonomy Structure:</h3>
									<pre id="taxonomyContent" style={{backgroundColor: 'white', padding: '10px', borderRadius: '4px', overflow: 'auto', maxHeight: '400px'}}></pre>
								</div>
							</div></div>
							<div className="project-section  media-segmentation-section">
							<button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapseSeventeen" aria-expanded="true" aria-controls="collapseSeventeen">
							<h1>Media Segmentation</h1><i className="fa fa-chevron-down acc"></i></button>
							<div id="collapseSeventeen" className="collapse show" aria-labelledby="headingSeventeen" >
								<div className="media-segmentation-bool"></div>
								<div className="media-segmentation-attributes"></div>
							</div></div>
							<div className="project-section type-NER attributes-section">
							<button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapseEighteen" aria-expanded="true" aria-controls="collapseEighteen">
							<h1>Document Attributes<span>required once for the entire project</span></h1><i className="fa fa-chevron-down acc"></i></button>
							<div id="collapseEighteen" className="collapse show" aria-labelledby="headingEighteen" >
								<div className="project-attributes-bool"></div>
								<div className="project-attributes"></div>
							</div></div>
							<div></div>
							<div className="project-section project-aws">
							<button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapseNineteen" aria-expanded="true" aria-controls="collapseNineteen">
							<h1>Web Hooks</h1><i className="fa fa-chevron-down acc"></i></button>
							<div id="collapseNineteen" className="collapse show" aria-labelledby="headingNineteen" >
								<div className="project-webhook-bool"></div>
								<div className="project-webhook-panel">
									<label htmlFor="taskwebhook">Task Update Webhook</label>
									<input placeholder="Enter Webhook Url" type="text" id="taskwebhook" className="mb-4 form-control" />
									<label htmlFor="projectwebhook">Project Update Webhook</label>
									<input placeholder="Enter Webhook Url" type="text" id="projectwebhook" className="mb-4 form-control" />
								</div>
							</div></div>
							<div className="project-section project-aws type-NER type-format">
							<button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapseTwenty" aria-expanded="true" aria-controls="collapseTwenty">
							<h1>Annotation Format</h1><i className="fa fa-chevron-down acc"></i></button>
							<div id="collapseTwenty" className="collapse show" aria-labelledby="headingTwenty" >
								<div className="project-export-panel">
									<select id="exportformat" className="mb-4 form-control" style={{width:250}}>
										<option value="0">ADL Default</option>
										<option value="1">Absolute Entity Offsets</option>
									</select>
								</div>
							</div></div>
							<div className="project-section project-aws project-aws-credentials">
							<button className=" btn-link bg-transparent btn-block text-left collapsed acc border-0" data-toggle="collapse" data-target="#collapseTwenty-One" aria-expanded="true" aria-controls="collapseTwenty-One">
							<h1>AWS Security<span>required only for projects with S3 files</span></h1><i className="fa fa-chevron-down acc"></i></button>
							<div id="collapseTwenty-One" className="collapse show" aria-labelledby="headingTwenty-One" >
							
								<div className="project-aws-bool"></div>
								<div className="project-aws-panel">
									<label htmlFor="awstype" className="">Type</label>
									<select id="awstype" className="mb-4 form-control">
										<option value="global">Use Global IAM Credentials</option>
										<option value="key">AWS Credentials</option>
										<option value="role" id="optrole">Role ARN</option>
									</select>


									<label htmlFor="awsrolearn" className="awstyperole">AWS Role ARN</label>
									<input placeholder="Aws_role_arn" type="text" id="awsrolearn" className="mb-4 form-control awstyperole" />
									<label htmlFor="awsexternalid" className="awstyperole">External Id</label>
									<input placeholder="Aws_external_id" type="text" id="awsexternalid" className="mb-4 form-control awstyperole" />


									<label htmlFor="awskey" className="awstypekey">AWS Access key</label>
									<input placeholder="Aws_access_key_id" type="text" id="awskey" className="mb-4 form-control awstypekey" />
									<label htmlFor="awssecret" className="awstypekey">Secret</label>
									<input placeholder="Aws_secret_access_key" type="text" id="awssecret" className="mb-4 form-control awstypekey" />
									<label htmlFor="awsregion" className="awstypekey">Region</label>
									<input placeholder="Aws_region" type="text" id="awsregion" className="mb-4 form-control awstypekey" />

									<label htmlFor="awsregion">Intermediate S3 Path: (for task processing)</label>
									<input placeholder="Intermediate S3 URL" type="text" id="awsintermediatepath" className="mb-4 form-control" />
								</div>
							</div></div>
						</div>
						
						{/* <a id="exportdescriptor" href="#">Export Descriptor</a> */}
					</div>

				</Col>
				<Col sm={2} className="mt-3 import-column">
					{/* <Button id="loaddescriptor" variant="primary" type="button" className="step2"><img className="svg_logo" src="imgs/descriptor.svg" />Load Descriptor</Button> */}
					<div id="descriptor" className="import-result">(load data)</div>
					<Button id="loadprojec" variant="primary" type="button" className="noshow"><img className="svg_logo" src="imgs/loading.svg" />Load Manifest</Button>
					<div id="manifest" className="import-result">(load data)</div>
					<Button id="import" variant="primary" type="button" className="noshow"><img className="svg_logo" src="imgs/import_file.svg" />Save Project</Button>
				</Col>

			</div>
			<div className="wizzbtn"></div>
		</div>

    )
}

export function CheckQA() {
		try {
			const qa_items = document.querySelectorAll(".option-item");
			console.log('qa_items-->', qa_items);
			const qa_items2 = document.querySelectorAll("div.option-item"); 
			const filteredItems = Array.from(qa_items2).filter(
				item => item.className === "option-item"
			); 
			const qa_items_count = filteredItems.length;
			console.log(`There are ${qa_items_count} the "option-item".`);
			console.log(filteredItems); 
		
			for (let i = 2; i <= qa_items_count; i++) {
				const qa_name = qa_items[i]?.querySelector('input[type="text"]');
				const qa_instructions = qa_items[i]?.querySelectorAll("textarea");
	
				if (qa_name && qa_name.value.trim() === "") {
					qa_name.placeholder = "Please Input Alias Name";
					qa_name.style.borderColor = 'red';
	
					// Reset the border color after 5 seconds
					setTimeout(() => {
						qa_name.style.borderColor = '';
					}, 3000);
	
					qa_name.focus();
					return false;
				}
	
				if (qa_instructions) {
					for (let j = 0; j < qa_instructions.length; j++) {
						if (qa_instructions[j].value.trim() === "") {
							qa_instructions[j].placeholder = "Please Input Instructions";
							qa_instructions[j].style.borderColor = 'red';
	
							// Reset the border color after 5 seconds
							setTimeout(() => {
								qa_instructions[j].style.borderColor = '';
							}, 3000);
	
							qa_instructions[j].focus();
							return false;
						}
					}
				}
			}
	
			return true;
		} catch (error) {
			console.error('Error in CheckQAMandatory function:', error);
			return false;
		}
	}


export default NlpImport;